<template src="./PaymentReports.template.html"></template>


<script type="text/javascript">
  import moment from "moment-timezone";
  import axios from 'axios';
  import Vue from "vue";
  import datePicker from "moment";
  import 'ag-grid-enterprise';
  import { AgGridVue } from "ag-grid-vue";
  import accounting from "accounting";
  import folioSettingModal from "../guestProfile/guestProfileDetailVue/folioSettingModal.vue";
  import JSZip from 'jszip';



  // import "ag-grid-enterprise";
  // import "ag-grid-enterprise/chartsModule";

  export default {
    name: "PaymentReports",
    props: [],
    data() {
      return {
        startDate: moment()
          .startOf("year")
          .format("DD MMM YYYY"),
        endDate: moment().format("DD MMM YYYY"),
        propertyList: [],
        propertyListForInvoice:[],
        unitListForInvoice:[],
        filterPropertyListForInvoice:[],
        filterUnitListForInvoice:[],
        unitTypeList:[],
        filteredProperties: [],
        unitClassList: [],
        sourceList: [],
        statusList: [],
        invoiceStatusList:[],
        PropertyId: [],
        UnitClassId: [],
        sourceID: [],
        statusId: [1, 3, 5, 6, 7],
        ledgeraccountlist: [],
        ledgeraccountId: [],
        paymentStatusList: [],
        paymentStatus: [],
        reportType: "Sales",
        lblTxt: "",
        valTxt: "",
        symbol: "",
        groupBy: "Month Consumed",
        showClearFilter: false,
        paymentAnalytics: {},
        dateType: "folioDate",
        groupByList: [
          {
            groupById: 1,
            groupByLabel: "Year Consumed"
          },
          {
            groupById: 2,
            groupByLabel: "Month Consumed"
          },
          {
            groupById: 3,
            groupByLabel: "Week Consumed"
          },
          {
            groupById: 4,
            groupByLabel: "Day Consumed"
          },
          // {
          //   groupById: 5,
          //   groupByLabel: "Booked Year"
          // },
          // {
          //   groupById: 6,
          //   groupByLabel: "Booked Month"
          // },
          // {
          //   groupById: 7,
          //   groupByLabel: "Booked Week"
          // },
          // {
          //   groupById: 8,
          //   groupByLabel: "Booked Day"
          // },

          {
            groupById: 10,
            groupByLabel: "Property"
          },
          {
            groupById: 11,
            groupByLabel: "Source"
          },
          {
            groupById: 12,
            groupByLabel: "Status"
          },
          {
            groupById: 13,
            groupByLabel: "Unit"
          },
          {
            groupById: 13,
            groupByLabel: "Unit Class"
          },
          {
            groupById: 9,
            groupByLabel: "Bedrooms"
          }
        ],
        filterSearchPropertyText: null,
        filterSearchPropertyText1:null,
        filterSearchUnitText:'',
        filterSearchstatusText:'',
        headerColumnList: {},
        headerColumnListForInvoiceDetails: {
                    Checkbox:{Label:'',ColumnName:'Checkbox',className: 'gp-actions-cell'},
                    Date: { Label: "Created/Due", ColumnName: "Date", className: 'gp-source-cell' },
                    InvoiceNo: {Label: "Invoice No",ColumnName: "GuestFirstName",className:'gp-source-cell',},
                    Description: {Label: "Description/Customer",ColumnName: "InvoiceNo",className: 'gp-name-cell',},
                    Amount: {Label: "Amount", ColumnName: "Revenue",className: 'gp-history-cell Amount'}             
                },
        paymentsHeaderColumnList: {
          GuestFullName: {
            Label: "GuestFullName",
            IsChecked: true,
            ColumnName: "Guest Name",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TempoConfirmationNumber: {
            Label: "TempoConfirmationNumber",
            IsChecked: true,
            ColumnName: "Confirmation #",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          ResStatusName: {
            Label: "ResStatusName",
            IsChecked: true,
            ColumnName: "Res Status",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          arrivalDate: {
            Label: "arrivalDate",
            IsChecked: true,
            ColumnName: "Arrival Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },

          departureDate: {
            Label: "departureDate",
            IsChecked: true,
            ColumnName: "Departure Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },

          BookedDate: {
            Label: "BookedDate",
            IsChecked: false,
            ColumnName: "Booked Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },

          TotalFoliocharges: {
            Label: "TotalFoliocharges",
            IsChecked: true,
            ColumnName: "Total",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          Balance: {
            Label: "Balance",
            IsChecked: true,
            ColumnName: "Balance",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          PropertyNickname: {
            Label: "PropertyNickname",
            IsChecked: true,
            ColumnName: "Property - unit",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          PropertyName: {
            Label: "PropertyName",
            IsChecked: false,
            ColumnName: "Property",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          UnitName: {
            Label: "UnitName",
            IsChecked: false,
            ColumnName: "Unit",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          UnitClassName: {
            Label: "UnitClassName",
            IsChecked: false,
            ColumnName: "Unit Class",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          PaymentStatusName: {
            Label: "PaymentStatusName",
            IsChecked: true,
            ColumnName: "Payment Status",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          PaymentDate: {
            Label: "PaymentDate",
            IsChecked: true,
            ColumnName: "Payment Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          Amount: {
            Label: "Amount",
            IsChecked: true,
            ColumnName: "Amount",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          FeeCollected: {
            Label: "FeeCollected",
            IsChecked: false,
            ColumnName: "Fee(s)",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          NetAmount: {
            Label: "NetAmount",
            IsChecked: false,
            ColumnName: "Net",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          MethodName: {
            Label: "MethodName",
            IsChecked: true,
            ColumnName: "Method",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          PayeeName: {
            Label: "PayeeName",
            IsChecked: true,
            ColumnName: "Payee Name",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          CompanyName: {
            Label: "CompanyName",
            IsChecked: true,
            ColumnName: "Company Name",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          InvoiceNumber: {
            Label: "InvoiceNumber",
            IsChecked: true,
            ColumnName: "Invoice Number",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          InvoiceGeneratedDate: {
            Label: "InvoiceGeneratedDate",
            IsChecked: true,
            ColumnName: "Invoice Generated Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          InvoiceDueDate: {
            Label: "InvoiceDueDate",
            IsChecked: true,
            ColumnName: "Invoice Due Date",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          }
        },
        salesHeaderColumnList: {
          GroupByName: {
            Label: "GroupByName",
            IsChecked: true,
            ColumnName: "Month Consumed",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          NetRescount: {
            Label: "NetRescount",
            IsChecked: true,
            ColumnName: "Net Res",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          NetNights: {
            Label: "NetNights",
            IsChecked: true,
            ColumnName: "Net Nights",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalStaycharges: {
            Label: "TotalStaycharges",
            IsChecked: true,
            ColumnName: "Stay",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalCleaningFees: {
            Label: "TotalCleaningFees",
            IsChecked: true,
            ColumnName: "Cleaning",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalOtherCharges: {
            Label: "TotalOtherCharges",
            IsChecked: true,
            ColumnName: "Other",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalTaxes: {
            Label: "TotalTaxes",
            IsChecked: true,
            ColumnName: "Taxes",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          Totalcharges: {
            Label: "Totalcharges",
            IsChecked: true,
            ColumnName: "Total",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          Occ: {
            Label: "Occ",
            IsChecked: true,
            ColumnName: "Occ %",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          CancOcc: {
            Label: "CancOcc",
            IsChecked: true,
            ColumnName: "Cancel %",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          AvgLOS: {
            Label: "AvgLOS",
            IsChecked: true,
            ColumnName: "Avg LOS",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          ADR: {
            Label: "ADR",
            IsChecked: true,
            ColumnName: "ADR",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          RevPAR: {
            Label: "RevPAR",
            IsChecked: true,
            ColumnName: "RevPAR",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalRescount: {
            Label: "TotalRescount",
            IsChecked: false,
            ColumnName: "Total Res",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          TotalNights: {
            Label: "TotalNights",
            IsChecked: false,
            ColumnName: "Total Nights",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          CancnoshowRes: {
            Label: "CancnoshowRes",
            IsChecked: false,
            ColumnName: "Canc Noshow Res",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          },
          CancnoshowNights: {
            Label: "CancnoshowNights",
            IsChecked: false,
            ColumnName: "Canc Noshow Nights",
            SortOder: "",
            isSortLoading: false,
            isAscOrDesc: null,
            isSortAscOrDesc: ""
          }
        },
        headerHeight: 50,
        groupHeaderHeight: 50,
        paymentReportList: [],
        salesReportList: [],
        options: {
          scrollbars: true,
          interactiveScrollbars: true,
          probeType: 3,
          mouseWheel: true,
          mouseWheelSpeed: 1
        },
        variable: false,
        pullDownTextObj: {
          trigger: "Loading...",
          begin: "Loading...",
          complete: "There are no items",
          error: "There is server error",
          refresh: "Loading..."
        },
        PageNumber: 1,
        loading: false,
        loadingInvoiceList: false, 
        totalLength: null,
        ItemsPerPage: 20,
        sideBar: null,
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          suppressSideBar: true,
          resizable: true,
          
          cellStyle: {
            "font-size": "14px",
            color: "#484848 ",
            "font-weight": 500
            // height: "200px"
            // "max-width":"150px"
          },
          lockPosition: true,
          // suppressSizeToFit: true,
          // width: 300,
          cellClass: "greenBackground",
          // unSortIcon: true
          // chartDataType: "series",
          allowedAggFuncs: ['sum', 'min', 'max'],
        },
        // aggFuncs: null,
        // domLayout: "print",
        gridOptions: {
          // enableCharts: true,
          // enableRangeSelection: true,
          // rowClass: "cellclass"
          // onCellClicked: getRoeData
          // suppressSetColumnStateEvents: true,
          getRowHeight: function (params) {
            return 50;
          },
          pivotMode: false
        },
        popupParent: document.body,
        rowGroupPanelShow: "always",
        paymentColumnDefs: [
          {
            headerName: "Reservation Information",
            children: [
              {
                headerName: "Guest Name",
                field: "GuestFullName",
                hide: false
                // sort: "desc"
              },
              {
                headerName: "Confirmation #",
                field: "TempoConfirmationNumber",
                hide: false
              },
              {
                headerName: "Res Status",
                field: "ResStatusName",
                hide: false
              },
              {
                headerName: "Arrival Date",
                field: "arrivalDate",
                hide: false
              },
              {
                headerName: "Departure Date",
                field: "departureDate",
                hide: false
              },
              {
                headerName: "Booked Date",
                field: "BookedDate",
                // columnGroupShow: "open",
                hide: true
              },
              {
                headerName: "Total",
                field: "TotalFoliocharges",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Balance",
                field: "Balance",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Property - unit",
                field: "PropertyNickname",
                hide: false
              },
              {
                headerName: "Property",
                field: "PropertyName",
                // columnGroupShow: "open",
                hide: true
              },
              {
                headerName: "Unit",
                field: "UnitName",
                // columnGroupShow: "open",
                hide: true
              },
              {
                headerName: "Unit Class",
                field: "UnitClassName",
                // columnGroupShow: "open",
                hide: true
              }
            ]
          },
          {
            headerName: "Payment Information",
            children: [
              {
                headerName: "Payment Status",
                field: "PaymentStatusName",
                hide: false
              },
              {
                headerName: "Payment Date",
                field: "PaymentDate",
                hide: false
                // rowGroup: true
              },
              {
                headerName: "Amount",
                field: "Amount",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Fee(s)",
                field: "FeeCollected",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                // columnGroupShow: "open",
                hide: true
              },
              {
                headerName: "Net",
                field: "NetAmount",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                // columnGroupShow: "open",
                hide: true
              },
              {
                headerName: "Method",
                field: "MethodName",
                hide: false
              },
              {
                headerName: "Payee Name",
                field: "PayeeName",
                hide: false
              },
              {
                headerName: "Company Name",
                field: "CompanyName",
                hide: false
              },
              {
                headerName: "Invoice Number",
                field: "InvoiceNumber",
                hide: false
              },
              {
                headerName: "Invoice Generated Date",
                field: "InvoiceGeneratedDate",
                valueFormatter: dateFormatter,
                hide: false
              },
              {
                headerName: "Invoice Due Date",
                field: "InvoiceDueDate",
                valueFormatter: dateFormatter,
                hide: false
              },
            ]
          }
        ],
        salesColumnDefs: [
          {
            headerName: "",
            children: [
              {
                headerName: "Month Consumed",
                field: "GroupByName",
                hide: false
                // sort: "desc"
              }
            ]
          },
          {
            headerName: "Net Bookings",
            children: [
              {
                headerName: "Total Res",
                field: "TotalRescount",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: true
                // width: 90
              },
              {
                headerName: "Total Nights",
                field: "TotalNights",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: true
                // width: 100
              },
              {
                headerName: "Net Res",
                field: "NetRescount",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: false
                // width: 100
              },
              {
                headerName: "Net Nights",
                field: "NetNights",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: false
                // width: 100
              },
              {
                headerName: "Canc Noshow Res",
                field: "CancnoshowRes",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: true
                // width: 100
              },
              {
                headerName: "Canc Noshow Nights",
                field: "CancnoshowNights",
                cellClass: "textalign",
                valueFormatter: numFormatter,
                hide: true
                // width: 100
              }
            ]
          },
          {
            headerName: "Revenue",
            children: [
              {
                headerName: "Stay",
                field: "TotalStaycharges",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
                //   aggFunc: sum
              },
              {
                headerName: "Cleaning",
                field: "TotalCleaningFees",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Other",
                field: "TotalOtherCharges",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Taxes",
                field: "TotalTaxes",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              },
              {
                headerName: "Total",
                field: "Totalcharges",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              }
            ]
          },
          {
            headerName: "Statistics",
            children: [
              {
                headerName: "Occ %",
                field: "Occ",
                valueFormatter: percengateFormatter,
                cellClass: "textalign",
                hide: false
                // width: 100
              },
              {
                headerName: "Cancel %",
                field: "CancOcc",
                valueFormatter: percengateFormatter,
                cellClass: "textalign",
                hide: false
                // width: 114
              },
              {
                headerName: "Avg LOS",
                field: "AvgLOS",
                cellClass: "textalign",
                valueFormatter: numberFormatter,
                // width: 109
                hide: false
              },
              {
                headerName: "ADR",
                field: "ADR",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
                // width: 145
              },
              {
                headerName: "RevPAR",
                field: "RevPAR",
                valueFormatter: currencyFormatter,
                cellClass: "twoDecimalPlaces",
                hide: false
              }
            ]
          }
        ],
        folioColumnDefs:[],
        excelStyles: [
          {
            id: "twoDecimalPlaces",
            numberFormat: { format: "$#,##0.00;[Red]$(#,##0.00)" },
            font: { size: "11" }
          },
          {
            id: "greenBackground",
            font: { size: "11" }
          },
          { id: "textalign", font: { size: "11" } },
          {
            id: "header",
            // font: { size: "12px" },
            font: { name: "Arial Black", family: 2, size: 10, bold: true },
            interior: {
              color: "#CCCCCC",
              pattern: "Solid"
            },
            borders: {
              borderBottom: {
                color: "#5687f5",
                lineStyle: "Continuous",
                weight: 1
              },
              borderLeft: {
                color: "#5687f5",
                lineStyle: "Continuous",
                weight: 1
              },
              borderRight: {
                color: "#5687f5",
                lineStyle: "Continuous",
                weight: 1
              },
              borderTop: {
                color: "#5687f5",
                lineStyle: "Continuous",
                weight: 1
              }
            }
          }
        ],
        columnDefs: null,
        rowData: null,
        gridApi: null,
        opens: "left",
        minDate: null,
        maxDate: null,
        // minDate: '',
        // maxDate: '',
        dateRange: {
          startDate: moment()
            .startOf("year")
            .format("DD MMM YYYY"),
          endDate: moment().format("DD MMM YYYY")
        },
        show_ranges: true,
        singleDatePicker: false,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        autoApply: false,
        showWeekNumbers: true,
        linkedCalendars: true,
        occupancy: null,
        stayNights: null,
        avgDailyRate: null,
        revPar: null,
        revenue: null,
        dateControll: null,
        userEntitlementList: null,
        filterObj: {
          PropertyId: -99,
          UnitClassId: -99,
          ViewListId: -5,
          SortBy: null,
          SortOrder: null,
          resSourceId: -99,
          TagsList: [],
          SearchText: [],
          Properties: [],
          UnitClasses: [],
          UnitTypes:[],
          Sources: [],
          Units: [],
          StatusList: [],
          Columns: [],
          PageNumber: 1,
          ItemsPerPage: 20,
          resid: null,
          userDate: moment().format("YYYY-MM-DD"),
          showUnAllocatedReservations:false,
          includeObsoleteInventory: false,
          autoGroupColumnDef: null,
          startCreatedDate:null,
          endCreatedDate:null,
          startDueDate:null,
          endDueDate:null,
        },
        folioDetailReportsData: [],
        folioDetailSummaryReport: [],
        InvoiceDetailsData:[],
        total:null,
        payments:null,
        count:null,
        due:null,
        overDue:null,
        selectedItems: [],
        reRender: false,
        selectedItemCount: 0,
        searchQuery:'',
        toggleFilterPanel : false,
        ClientId:null,
        UserId:null,
        clearTags: false,
        customViewList: [],
        selectedViewObj: null,
        selectedFilterColumn: null,
        filterSearchTagText: null,
        filterSearchUnitClassText: null,
        filterSearchUnitTypeText:null,
        filterSearchSourceTypeText: null,
        filterSearchUnitNameText: null,
        filterSearchUnitNameText1:null,
        filterSearchStatusText: null,
        dateFormat: 'DD MMM YYYY',
        stayDateRange: { startDate: null, endDate: null },
        stayDateRange1: { startDate: null, endDate: null }, 
        filterColumnsDateRange: { startDate: null, endDate: null },
        filterColumnsDateRange2: { startDate: null, endDate: null },
        showPropertyList: false,
        showunitNameList: false,
        showunitList: false,
        unitList: [],
        showstatusList: false,
        GetInvoiceCardDetails:[],
        GetInvoiceItemDetails:[],
        filterObjForInvoice:{
        statusList: [],
        filterstatusList:[],
        startCreatedDate:null,
        endCreatedDate:null,
          startDueDate:null,
          endDueDate:null,
        },
        viewSaveObject: {
          properties: [],
          UnitClasses: [],
          UnitTypes:[],
          sources: [],
          units: [],
          statusList: [],
          startCreatedDate:null,
          endCreatedDate:null,
          startDueDate:null,
          endDueDate:null,
        },
        selectedAction: 'Actions',
        isLoading: false,
        propertyId: [],
        selectedAll:false,
        showInvocieDetail: false,
        selectedInvoiceItem: {},
        balanceTransferDetails:[],
        balanceTransferDetailsData:[],
        apiUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : ""),
        corporateDetails:[],
        guestInfo: {
          SourceName: "Tempo",
          SubSourceName: "",
          SourceId: 1,
        },
        selectedInvoiceObj: {},
        showSettingModal: false,
        modalParams: {},
        guestData: {
          SourceName: "Tempo",
          SubSourceName: "",
          SourceId: 1,
        },
        guestEmails: [],
        masterFolioList: [],
        totalAmountVal: null,
        totalTaxVal: null,
        totalFolioAmount: null,
        totalBalanceTransfer: null,
        GuestProfileId: "-1",
        additionalPhoneNumbers: [
          {
            PhoneNumber: null,
            ReservationId: null,
          },
        ],
        additionalEmails: [
          {
            Emailaddress: null,
            ReservationId: null,
          },
        ],
        isMasterFolioAvailable: null,
        roomInfo: {
          Persons: null,
          NumberOfAdults: null,
          NumberOfChildren: null,
          formattedStartDate: null,
          formattedEndDate: null,
          isActive: false,
          StartDate: null,
          EndDate: null,
        },
        emailList: null,
        selectedResId: null,
        reservationStatus: null,
        showFolioDetails: false,
        bulkPdfData:[],
        isLoad:false,
        parentComp1: '',
      selectedInvoiceObj1: {},
      guestInfo1: {},
      additionalEmails1: [],
      balanceTransferDetails1: {},
      roomInfo1: {},
      emailList1: [],
      folioItemsDetails1: [],
      Reservation_Status1: '',
      getTotalAmount1: 0,
      totalAmountVal1: 0,
      totalBalanceTransfer1: 0,
      totalTaxVal1: 0,
      corporateDetails1: {},
      corporateEmail1: [],
      corporatePhoneNo1: [],
      companyProfileId1: '',
      clientId1: '',
      isMasterFolioAvailable1: false,
      isEditable: false,
      invoicedetails1:{},
      modalKey: 0,
      };
    },
    components: {
      AgGridVue,
      folioSettingModal
    },
    methods: {
      resetModalData() {
      this.modalKey += 1;
    },
      getTotalAmount(amount, tax) {
        return (amount + tax).toFixed(2);
      },
      settingAction(modalParams,showSettingModal){
        let vm = this;
        vm.showSettingModal = showSettingModal;
        vm.modalParams = modalParams;
      },
      showInvoiceDetailPanel(invoiceItem){
        let vm = this;
        if(invoiceItem.isvoided){
          return;
        }
        vm.showInvocieDetail = !vm.showInvocieDetail;
        vm.selectedInvoiceItem = invoiceItem
      },
      filterChanged() {
        if (this.reportType == "Sales") {
          let groupByCols = {
            occupancy: 0,
            stayNights: 0,
            avgDailyRate: 0,
            revenue: 0
          };
          this.gridApi.forEachNodeAfterFilter((node, index) => {
            if (!node.group) {
              // index + " -> data: " + node.data.country + ", " + node.data.athlete;
              console.log(node.data);
              groupByCols.stayNights +=
                node.data.Nights > 0 ? node.data.Nights : 0;
              groupByCols.occupancy += node.data.Occ > 0 ? node.data.Occ : 0;
              groupByCols.avgDailyRate += node.data.ADR > 0 ? node.data.ADR : 0;
              groupByCols.revenue +=
                node.data.Totalcharges > 0 ? node.data.Totalcharges : 0;
            }
          });

          this.stayNights = groupByCols.stayNights;
          this.occupancy = groupByCols.occupancy;
          this.avgDailyRate = groupByCols.avgDailyRate;
          this.revenue = groupByCols.revenue;
        }
      },
      getcurrencysymbol(amount) {
        if (amount >= 1000000000) {
          return "G";
        } else if (amount >= 1000000) {
          return "M";
        } else if (amount >= 1000) {
          return "K";
        } else {
          return null;
        }
      },
      formatMoneyWithout(amount) {
        let currency = accounting.formatMoney(amount, {
          symbol: "",
          format: {
            pos: "%s %v",
            neg: "%s (%v)",
            zero: "%s  %v"
          },
          thousand: ",",
          precision: 0,
          decimal: "."
        });

        return currency;
      },
      formatMoney(amount) {
        let currency;
        if (amount >= 1000000000) {
          currency = amount / 1000000000;
        } else if (amount >= 1000000) {
          currency = amount / 1000000;
        } else if (amount >= 1000) {
          currency = amount / 1000;
        } else {
          currency = amount;
        }
        currency = accounting.formatMoney(currency, {
          symbol: "",
          format: {
            pos: "%s %v",
            neg: "%s (%v)",
            zero: "%s  %v"
          },
          thousand: ",",
          precision: 0,
          decimal: "."
        });

        return currency;
        // return this.$store.state.getFormattedAmount("", amount);
      },
      formatNights(Nights) {
        return accounting.formatMoney(Nights, {
          symbol: "",
          format: {
            pos: "%s %v",
            neg: "%s (%v)",
            zero: "%s  %v"
          },
          thousand: ",",
          precision: 0,
          decimal: "."
        });
      },
      formatDate(dateString) {
          if (!dateString) return '-'; // Return '-' if dateString is falsy

          const date = new Date(dateString); // Parse the dateString into a Date object
          const day = String(date.getDate()).padStart(2, '0'); // Get the day with leading zero if needed
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const month = monthNames[date.getMonth()]; // Get the month abbreviation
          const year = date.getFullYear(); // Get the year

          return `${day} ${month} ${year}`; // Return the formatted date string
        },
      changeGridView(reportType) {
        let vm = this;
        vm.reportType = reportType;
        vm.gridOptions.pivotMode = false
        vm.sideBar = null;
        this.gridApi.hideOverlay();
        if (vm.reportType == "Payments") {
          vm.groupBy = "Month Consumed";
          vm.columnDefs = vm.paymentColumnDefs;
          vm.rowData = vm.paymentReportList;
          vm.dateType = "paymentDate";
          vm.salesHeaderColumnList.GroupByName.ColumnName = "Month Consumed";
          Object.keys(vm.paymentsHeaderColumnList).forEach(function (key) {
            if (
              key == "BookedDate" ||
              key == "PropertyName" ||
              key == "UnitName" ||
              key == "UnitClassName" ||
              key == "FeeCollected" ||
              key == "NetAmount"
            ) {
              vm.paymentsHeaderColumnList[key].IsChecked = false;
              vm.gridOptions.columnApi.setColumnVisible(
                vm.paymentsHeaderColumnList[key].Label,
                false
              );
            } else {
              vm.paymentsHeaderColumnList[key].IsChecked = true;
              vm.gridOptions.columnApi.setColumnVisible(
                vm.paymentsHeaderColumnList[key].Label,
                true
              );
            }
          });
          vm.headerColumnList = vm.paymentsHeaderColumnList;
          vm.clearFilter();
          // vm.GetPaymentdetails_report(vm.reportType);
        } else if (vm.reportType == "Sales") {
          vm.salesColumnDefs[0].children[0].headerName = vm.groupBy;
          vm.columnDefs = vm.salesColumnDefs;
          vm.rowData = vm.salesReportList;
          vm.dateType = "folioDate";
          Object.keys(vm.salesHeaderColumnList).forEach(function (key) {
            if (
              key == "TotalRescount" ||
              key == "TotalNights" ||
              key == "CancnoshowRes" ||
              key == "CancnoshowNights"
            ) {
              vm.salesHeaderColumnList[key].IsChecked = false;
              vm.gridOptions.columnApi.setColumnVisible(
                vm.salesHeaderColumnList[key].Label,
                false
              );
            } else {
              vm.salesHeaderColumnList[key].IsChecked = true;
              vm.gridOptions.columnApi.setColumnVisible(
                vm.salesHeaderColumnList[key].Label,
                true
              );
            }
          });
          // Object.keys(vm.salesHeaderColumnList).forEach(function (key) {
          //   vm.salesHeaderColumnList[key].IsChecked = true;
          //   vm.gridOptions.columnApi.setColumnVisible(
          //     vm.salesHeaderColumnList[key].Label,
          //     true
          //   );
          // });
          vm.headerColumnList = vm.salesHeaderColumnList;
          vm.clearFilter();
          // vm.Get_SalesReport(vm.reportType);
        }else if (vm.reportType == "foliodetail") {
          vm.groupBy = "Month Consumed";
          vm.columnDefs = vm.folioColumnDefs;
          vm.rowData = vm.folioDetailReportsData;
          vm.dateType = "folioDate";
          // vm.gridOptions.pivotMode = true
          vm.sideBar = "columns";
          Object.keys(vm.folioColumnDefs).forEach(function (key) {
            
          })
          //   if (
          //     key == "TotalRescount" ||
          //     key == "TotalNights" ||
          //     key == "CancnoshowRes" ||
          //     key == "CancnoshowNights"
          //   ) {
          //     vm.salesHeaderColumnList[key].IsChecked = false;
          //     vm.gridOptions.columnApi.setColumnVisible(
          //       vm.salesHeaderColumnList[key].Label,
          //       false
          //     );
          //   } else {
          //     vm.salesHeaderColumnList[key].IsChecked = true;
          //     vm.gridOptions.columnApi.setColumnVisible(
          //       vm.salesHeaderColumnList[key].Label,
          //       true
          //     );
          //   }
          // });
          // Object.keys(vm.salesHeaderColumnList).forEach(function (key) {
          //   vm.salesHeaderColumnList[key].IsChecked = true;
          //   vm.gridOptions.columnApi.setColumnVisible(
          //     vm.salesHeaderColumnList[key].Label,
          //     true
          //   );
          // });
          vm.headerColumnList = vm.folioColumnDefs;
          vm.clearFilter();
          // vm.Get_SalesReport(vm.reportType);
        }else if(vm.reportType == "Corporate Invoices"){
          vm.dateType='Corporate Invoices';
          vm.getInvoiceList();
          vm.clearFilter();
        }
        vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        vm.$store.state.bus.$emit("reportType", vm.reportType);
      },
      autoSizeAll() {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
          // if(column.colId != "GroupByName"){
          allColumnIds.push(column.colId);
          // }
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds);
      },
      sizeToFit() {
        this.gridApi.sizeColumnsToFit();
      },
      changeFirstColName() {
        let vm = this;
        vm.salesColumnDefs[0].children[0].headerName = vm.groupBy;
        // vm.columnDefs = vm.salesColumnDefs;
        // vm.gridOptions.api.setColumnDefs(vm.columnDefs);
        vm.headerColumnList.GroupByName.ColumnName = vm.groupBy;
        vm.Get_SalesReport(vm.reportType);
        console.log(vm.salesColumnDefs[0].children[0].headerName);
      },
      onRowClicked(e) {
        // alert("hai",e)
        // var selectedRows = this.gridApi.getSelectedRows();
        console.log("params", e.node.data);
      },
      updateValues(values) {
        this.dateRange.startDate = moment(values.startDate).format("DD MMM YYYY");
        this.dateRange.endDate = moment(values.endDate).format("DD MMM YYYY");
        console.log("event: update", values);
        this.startDate = values.startDate;
        this.endDate = values.endDate;
        this.dateType = values.dateType;
        // alert(this.dateType);
      },
      checkOpen(open, togglePicker) {
        console.log("event: open", open, togglePicker);
        this.dateControll = open;
      },
      checkDateControl() {
        let vm = this;
        if (this.dateControll == true) {
          this.dateControll = false;
          vm.$store.state.bus.$emit("dateControll", false);
        }
      },
      // updateValues(values) {
      //   let vm = this;
      //   console.log(values);
      //   vm.startDate = moment(values.startDate).format("DD MMM YYYY");
      //   vm.endDate = moment(values.endDate).format("DD MMM YYYY");
      // },
      getPropertiesBySearchText(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {
            searchText: searchText
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("...response.propertyList", response.propertyList);

              vm.propertyList.splice(
                0,
                vm.propertyList.length,
                ...response.propertyList
              );
            }
          }
        });
      },
      getPropertiesBySearchText1(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler",
          {
            key: "GetPropertiesBySearchText",
            params: {
              searchText: searchText
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response) {
                // console.log("...response.propertyList thimmappa ======>", response.propertyList)

                let List = response.propertyList;
                for (var i = 0; i < vm.filterPropertyListForInvoice.length; i++) {
                  // console.log("vm.filterObjForInvoice.propertyNamesAndId", vm.filterPropertyListForInvoice[i].PropertyId)
                  let index = List.findIndex(x => x.PropertyId == vm.filterPropertyListForInvoice[i].PropertyId);
                  if (index > -1)
                    List.splice(index, 1);
                  // console.log("index", index);
                }

                vm.propertyListForInvoice.splice(0, vm.propertyListForInvoice.length, ...List);
              }
            }
          });
      },
      getUnitNamesBySearchText1(searchText) {
        let vm = this;
        let resultObj = vm.filterPropertyListForInvoice.map(obj => obj.PropertyId);
        // console.log("thimmappa============>",resultObj)
        vm.$store.dispatch("dataRequestHandler",
          {
            key: "GetUnitListBySearchText",
            params: {
              searchText: searchText,
              PropertyId: resultObj.toString()
            },
            callback: function (err, response) {
              if (err) {
                return;
              }
              if (response) {
                // console.log("getUnitNamesBySearchText1 thimmappa",response)
                let List = response.unitList;
                for (var i = 0; i < vm.filterUnitListForInvoice.length; i++) {
                  // console.log("vm.filterObj.Units[i].UnitId", vm.filterUnitListForInvoice[i].UnitId)
                  let index = List.findIndex(x => x.UnitId == vm.filterUnitListForInvoice[i].UnitId);
                  if (index > -1)
                    List.splice(index, 1);
                  // console.log("index", index);
                }

                vm.unitListForInvoice.splice(0, vm.unitListForInvoice.length, ...List);
              }
            }
          });
      },
      GetUnitClasssListBySearchText(searchText) {
        let vm = this;
        var items = document.getElementsByName("unitTypeCheckedClass");
        for (var i = 0; i < items.length; i++) {
          if (items[i].type == "checkbox") items[i].checked = false;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUnitClasssListBySearchText",
          params: {
            searchText: searchText,
            PropertyId: vm.PropertyId
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response", response);
              vm.unitClassList.splice(
                0,
                vm.unitClassList.length,
                ...response.unitClassList
              );
              vm.UnitClassId.splice(0);
            }
          }
        });
      },
      GetFolioDetailReport(searchText) {
        let vm = this;
     
        vm.filterObj.Properties = []
        vm.PropertyId.forEach(PropertyId=>{
          vm.filterObj.Properties.push({
            PropertyId: PropertyId
          })
        })
        vm.filterObj.UnitClasses = []
        vm.UnitClassId.forEach(UnitClass=>{
          vm.filterObj.UnitClasses.push({
            UnitClassId: UnitClass
          })
        })
        vm.filterObj.Sources = []
        vm.sourceID.forEach(source=>{
          vm.filterObj.Sources.push({
            sourceID: source
          })
        })
        vm.filterObj.StatusList = []
        vm.statusId.forEach(status=>{
          vm.filterObj.StatusList.push({
            StatusId: status
          })
        })

        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_FolioDetails_allreservation_forreporting",
          params: {
            filterObj: JSON.stringify(vm.filterObj),
            selectedSearchText: [],
            ViewListId: -1,
            userDate: moment().format("YYYY-MM-DD HH:mm:ss")
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response", response);
              vm.folioColumnDefs.splice(0)
              if(response[2] && response[2].length > 0 ){
                Object.keys(response[2][0]).forEach((key)=>{
                  if(key == "Ledger Account Name"){
                      vm.folioColumnDefs.push({
                      headerName: key,
                      field: key,
                      hide: true,
                      cellClass: "textalign",
                      // rowGroup: true, 
                      enableRowGroup: true,
                      // pivot: true,
                      enablePivot: true,
                    })
                  }
                  else if(key == "Amount"){
                      vm.folioColumnDefs.push({
                      headerName: key,
                      field: key,
                      hide: false,
                      valueFormatter: currencyFormatter,
                      cellClass: "twoDecimalPlaces",
                      enableRowGroup: true,
                      enablePivot: true,
                      // aggFunc: 'sum' ,
                      // sortable: true,
                    })
                  }else{
                      vm.folioColumnDefs.push({
                      headerName: key,
                      field: key,
                      hide: true,
                      cellClass: "textalign",
                      // pivot: true,
                      enableRowGroup: true,
                      enablePivot: true
                      // sortable: true,
                    })
                  
                  }
                
                })
              }
              vm.folioDetailReportsData.splice(
                0,
                vm.folioDetailReportsData.length,
                ...response[2]
              );
              vm.folioDetailReportsData.forEach(foliodata=>{
                foliodata["Arrival Date"] = moment(foliodata["Arrival Date"]).format("DD MMM YYYY")
                foliodata["Departure Date"] = moment(foliodata["Departure Date"]).format("DD MMM YYYY")
                foliodata["Date Booked"] = moment(foliodata["Date Booked"]).format("DD MMM YYYY")
                foliodata["Folio Item Date"] = moment(foliodata["Folio Item Date"]).format("DD MMM YYYY")
              })
              vm.folioDetailSummaryReport.splice(
                0,
                vm.folioDetailSummaryReport.length,
                ...response[4]
              );
            }
          }
        });
      },
      getSourceListBySearchText(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetSourceListBySearchText",
          params: {
            searchText: searchText
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.sourceList.splice(
                0,
                vm.sourceList.length,
                ...response.sourceList
              );
            }
          }
        });
      },
      getStatusBySearchText(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetResevationStatusListBySearchText",
          params: {
            searchText: searchText
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.statusList.splice(
                0,
                vm.statusList.length,
                ...response.statusList
              );
            }
          }
        });
      },
      GetPaymentdetails_report(reportType) {
        let vm = this;
        vm.headerColumnList = vm.paymentsHeaderColumnList;
        vm.reportType = reportType;
        let propertyId = vm.PropertyId.join();
        let UnitClassId = vm.UnitClassId.join();
        let sourceID = vm.sourceID.join();
        let statusId = vm.statusId.join();
        let ledgeraccountId = vm.ledgeraccountId.join();
        let paymentStatus = vm.paymentStatus.join();
        vm.loading = true;
        let type = 1;
        if (vm.dateType == "paymentDate") {
          type = 1;
        } else if (vm.dateType == "stayDate") {
          type = 2;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPaymentdetails_report",
          params: {
            startDate: moment(vm.startDate).format("YYYY-MM-DD"),
            endDate: moment(vm.endDate).format("YYYY-MM-DD"),
            PropertyId: propertyId ? propertyId : null,
            UnitClassId: UnitClassId ? UnitClassId : null,
            resSourceID: sourceID ? sourceID : null,
            statusId: statusId ? statusId : null,
            ledgeraccountId: ledgeraccountId ? ledgeraccountId : null,
            paymentStatus: paymentStatus ? paymentStatus : null,
            groupBy: vm.groupBy,
            PageNo: vm.PageNumber,
            ItemsPerPage: vm.ItemsPerPage,
            dateType: type
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in GetPaymentdetails_report", err);
              return;
            }
            if (response) {
              vm.loading = false;
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Payment Reports rendered successfully",
                header: ""
              });
              vm.paymentReportList.splice(
                0,
                vm.paymentReportList.length,
                ...response[0]
              );
              vm.paymentAnalytics = response[1][0];
              // AmountAuthorized: 1765;
              // AmountFailed: 0;
              // AmountRefunded: 80.89;
              // Nooftransactions: 19;
              // TotalAmount: 10299.01;
              if (vm.reportType == "Payments") {
                vm.groupBy = "Month Consumed";
                vm.columnDefs = vm.paymentColumnDefs;
                vm.rowData = vm.paymentReportList;
              }
              // else if (vm.reportType == "Sales") {
              //   vm.columnDefs = vm.salesColumnDefs;
              //   vm.rowData = vm.salesReportList;
              // }
              setTimeout(() => {
                vm.gridOptions.api.setColumnDefs(vm.columnDefs);
                // vm.autoSizeAll();
                vm.sizeToFit();
              }, 100);
              let coldata = vm.gridOptions.columnApi.addValueColumn("Total");
              // vm.$nextTick(vm.filterChanged);
              // vm.gridOptions.api.sizeColumnsToFit();
              console.log("response in GetPaymentdetails_report", coldata);
            }
          }
        });
      },
      Get_SalesReport(reportType) {
        let vm = this;
        vm.reportType = reportType;
        let propertyId = vm.PropertyId.join();
        let UnitClassId = vm.UnitClassId.join();
        let sourceID = vm.sourceID.join();
        let statusId = vm.statusId.join();
        vm.loading = true;
        let type = 1;
        if (vm.dateType == "folioDate") {
          type = 1;
        } else if (vm.dateType == "arrivedOn") {
          type = 2;
        } else if (vm.dateType == "bookedOn") {
          type = 3;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_SalesReport",
          params: {
            startDate: moment(vm.startDate).format("YYYY-MM-DD"),
            endDate: moment(vm.endDate).format("YYYY-MM-DD"),
            PropertyId: propertyId ? propertyId : null,
            UnitClassId: UnitClassId ? UnitClassId : null,
            resSourceID: sourceID ? sourceID : null,
            statusId: statusId ? statusId : null,
            groupBy: vm.groupBy,
            PageNo: vm.PageNumber,
            ItemsPerPage: vm.ItemsPerPage,
            dateType: type
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_SalesReport", err);
              return;
            }
            if (response) {
              vm.loading = false;
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Sales Reports rendered successfully",
                header: ""
              });
              vm.salesReportList.splice(
                0,
                vm.salesReportList.length,
                ...response[1]
              );
              vm.occupancy = response[0][0].OccupancyPercentage;
              vm.stayNights = response[0][0].StayNights;
              vm.avgDailyRate = response[0][0].ADR;
              vm.revPar = response[0][0].TotalRevPAR;
              vm.revenue = response[0][0].TotalRevenue;
              vm.totalLength = response[1].length;
              // if (vm.reportType == "Payments") {
              // vm.groupBy = "Month Consumed";
              // vm.columnDefs = vm.paymentColumnDefs;
              // vm.rowData = vm.paymentReportList;
              // } else
              if (vm.reportType == "Sales") {
                vm.columnDefs = vm.salesColumnDefs;
                vm.rowData = vm.salesReportList;
              }
              setTimeout(() => {
                vm.gridOptions.api.setColumnDefs(vm.columnDefs);
                // vm.autoSizeAll();
                vm.sizeToFit();
              }, 100);

              // vm.gridOptions.api.sizeColumnsToFit();
              console.log("response in Get_SalesReport", response);
              // vm.$nextTick(vm.filterChanged);
            }
          }
        });
      },
      onFirstDataRendered(params) {
        this.api.sizeColumnsToFit();
      },
      getFilteredData(reportType) {
        let vm = this;
        if (reportType == "Sales") {
          vm.Get_SalesReport(reportType);
          if (
            vm.PropertyId.length > 0 ||
            vm.UnitClassId.length > 0 ||
            vm.sourceID.length > 0 ||
            vm.statusId.includes(4) ||
            vm.statusId.includes(8) ||
            vm.statusId.includes(9) ||
            vm.statusId.includes(10) ||
            vm.statusId.includes(11)
          ) {
            vm.showClearFilter = true;
          } else {
            vm.showClearFilter = false;
          }
        } else if (reportType == "Payments") {
          if (
            vm.PropertyId.length > 0 ||
            vm.UnitClassId.length > 0 ||
            vm.sourceID.length > 0 ||
            vm.ledgeraccountId.length > 0 ||
            vm.paymentStatus.length > 0
          ) {
            vm.showClearFilter = true;
          } else {
            vm.showClearFilter = false;
          }
          vm.GetPaymentdetails_report(reportType);
        }else if (reportType == "foliodetail") {
          if (
            vm.PropertyId.length > 0 ||
            vm.UnitClassId.length > 0 ||
            vm.sourceID.length > 0 ||
            vm.ledgeraccountId.length > 0 ||
            vm.paymentStatus.length > 0
          ) {
            vm.showClearFilter = true;
          } else {
            vm.showClearFilter = false;
          }
          vm.GetFolioDetailReport();
        }
      },
      clearFilter() {
        let vm = this;
        vm.startDate = moment()
          .startOf("year")
          .format("DD MMM YYYY");
        vm.endDate = moment().format("DD MMM YYYY");
        this.dateRange.startDate = moment()
          .startOf("year")
          .format("DD MMM YYYY");
        this.dateRange.endDate = moment().format("DD MMM YYYY");
        vm.PropertyId.splice(0);
        vm.UnitClassId.splice(0);
        vm.sourceID.splice(0);
        vm.statusId = [1, 3, 5, 6, 7];
        vm.ledgeraccountId.splice(0);
        vm.paymentStatus.splice(0);
        vm.showClearFilter = false;
        // vm.groupBy = "Month Consumed"
        var items = document.getElementsByName("checkclass");
        for (var i = 0; i < items.length; i++) {
          if (items[i].type == "checkbox") items[i].checked = false;
        }
        var checkedData = document.getElementsByName("unitTypeCheckedClass");
        for (var i = 0; i < checkedData.length; i++) {
          if (checkedData[i].type == "checkbox") checkedData[i].checked = false;
        }
        console.log("vm.PropertyId", vm.PropertyId);
        if (vm.reportType == "Payments") {
          vm.GetPaymentdetails_report(vm.reportType);
        } else if (vm.reportType == "Sales") {
          vm.Get_SalesReport(vm.reportType);
        } else if (vm.reportType == "foliodetail") {
          vm.GetFolioDetailReport();
        }
      },
      getStartDate(StartDate) {
        console.log("date StartDate");
        return StartDate ? moment(StartDate).format("DD MMM YYYY") : "";
      },
      getEndDate(EndDate) {
        console.log("date EndDate");
        return EndDate ? moment(EndDate).format("DD MMM YYYY") : "";
      },
      getPaymentDate(PaymentDate) {
        console.log("date PaymentDate");
        return PaymentDate ? moment(PaymentDate).format("DD MMM YYYY") : "";
      },
      selectColumn(column, event) {
        let vm = this;
        let isAnyColumnUnchecked = false;
        Object.keys(vm.headerColumnList).forEach(function (key) {
          if (
            !vm.headerColumnList[key]["IsChecked"] ||
            !event.currentTarget.checked
          ) {
            isAnyColumnUnchecked = true;
          }
        });
        if (event.target.checked) {
          column.IsChecked = true;
          for (let col of vm.columnDefs) {
            for (let colchildren of col.children) {
              if (colchildren.headerName == column.ColumnName) {
                console.log(colchildren.headerName);
                console.log(column.ColumnName);
                console.log(colchildren.field);
                console.log(column.Label);
                console.log(vm.columnDefs);
                vm.gridOptions.columnApi.setColumnVisible(
                  colchildren.field,
                  true
                );
              }
            }
          }
        } else {
          column.IsChecked = false;
          for (let col of vm.columnDefs) {
            for (let colchildren of col.children) {
              if (colchildren.headerName == column.ColumnName) {
                console.log(colchildren.headerName);
                console.log(column.ColumnName);
                console.log(colchildren.field);
                console.log(column.Label);
                console.log(vm.columnDefs);
                vm.gridOptions.columnApi.setColumnVisible(
                  colchildren.field,
                  false
                );
              }
            }
          }
        }
        setTimeout(() => {
          // vm.gridOptions.api.setColumnDefs(vm.columnDefs);
          vm.autoSizeAll();
          this.gridApi.sizeColumnsToFit();
        }, 100);
      },
      setPerviousYearDate() {
        let vm = this;
        console.log("startDate1 == ", vm.startDate);
        vm.dateRange.endDate = moment().format("DD MMM YYYY");
        vm.dateRange.startDate = moment(vm.dateRange.endDate)
          .subtract("months", 11)
          .format("DD MMM YYYY");
        console.log("startDate2 == ", vm.startDate);
        console.log("endDate == ", vm.endDate);
        vm.GetPaymentdetails_report(vm.reportType);
      },
      getMoreData($stateChange) {
        if (this.paymentReportList.length >= this.totalLength) {
          $stateChange("complete");
        } else {
          setTimeout(() => {
            //   // let length = this.items.length
            //   // for (let i = length; i < length + 20; i++) {
            //   //   this.items.push({
            //   //     text: i,
            //   //     id: i,

            //   //   })
            //   // }
            //   // this.filterObj.PageNumber = this.filterObj.PageNumber + 1;

            $stateChange("loaded");
          }, 1500);
          this.loading = false;
          this.PageNumber++;
          // this.GetPaymentdetails_report(vm.reportType);
        }
      },
      async downloadFileFromURL(publicURL,type){
        // Fetch the file from the URL
      const response = await fetch(publicURL);
      const blob = await response.blob();

      // Create a link element
      const link = document.createElement('a');

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Set the href property of the link to the blob URL
      const formattedDate = moment().format("YYYY MM DD");
      link.href = url;

      // Set the download attribute with a filename
      link.download = `Invoice ${type}-${formattedDate}.xlsx`; // Change the filename as needed

      // Append the link to the document body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the document
      document.body.removeChild(link);

      // Revoke the object URL to free up memory
      window.URL.revokeObjectURL(url);
      },
      refreshData($pullStateChange) {
        setTimeout(() => {
          this.paymentReportList.splice(0);
          for (let i = 0; i < 50; i++) {
            this.paymentReportList.push({
              text: i,
              id: i
            });
          }
          $pullStateChange("complete");
        }, 1500);
      },
      downloadCorporateInvoiceList(type){
        let vm = this;
        const folioIds = vm.selectedItems.map(item => item.FolioId);
        const filterColumns = [
                      {
                          ColumnName: "Propertyid",
                          ColumnText: vm.viewSaveObject.properties.map(Property => Property.PropertyId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "UnitID",
                          ColumnText: vm.viewSaveObject.UnitTypes.map(Unit => Unit.UnitId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "FolioStatusID",
                          ColumnText: vm.viewSaveObject.statusList.map(status => status.folioStatusID).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "CreatedDate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startCreatedDate,
                          EndDate: vm.viewSaveObject.endCreatedDate
                      },
                      {
                          ColumnName: "Duedate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startDueDate,
                          EndDate: vm.viewSaveObject.endDueDate
                      },
                      {
                          ColumnName: "FolioId",
                          ColumnText: folioIds,
                          StartDate: null,
                          EndDate: null
                      }
        ];
        vm.$store.dispatch("dataRequestHandler", {
          key: "downloadCorporateInvoiceList",
          params: {
            ClientId: vm.ClientId,
                UserId:vm.UserId,
                SearchText:vm.searchQuery,
                FilterColumns:filterColumns
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              // console.log("downloadCorporateInvoiceList response ===>", response);
              if(response && response.fileUrl){
                // console.log("vm ===>",vm);          
                vm.downloadFileFromURL(response.fileUrl,'List')
                vm.$store.dispatch("toastr", {
                  type: "info",
                  header: "Information!",
                  message: "Exporting invoice list to" + "Excel "
                });
      
              }
            }
          }
        });
      },
      downloadCorporateInvoiceDetail(type){
        let vm = this;
        // console.log("selectedItems before mapping:", vm.selectedItems);
        const folioIds = vm.selectedItems.map(item => item.FolioId).join(',');
        // Log folioIds to ensure they're correctly extracted
        // console.log("Extracted FolioIds:", folioIds);
        const filterColumns = [
                      {
                          ColumnName: "Propertyid",
                          ColumnText: vm.viewSaveObject.properties.map(Property => Property.PropertyId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "UnitID",
                          ColumnText: vm.viewSaveObject.UnitTypes.map(Unit => Unit.UnitId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "FolioStatusID",
                          ColumnText: vm.viewSaveObject.statusList.map(status => status.folioStatusID).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "CreatedDate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startCreatedDate,
                          EndDate: vm.viewSaveObject.endCreatedDate
                      },
                      {
                          ColumnName: "Duedate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startDueDate,
                          EndDate: vm.viewSaveObject.endDueDate
                      },
                      {
                          ColumnName: "FolioId",
                          ColumnText: folioIds,
                          StartDate: null,
                          EndDate: null
                      }
        ];
        vm.$store.dispatch("dataRequestHandler", {
          key: "downloadCorporateInvoiceDetails",
          params: {
            ClientId: vm.ClientId,
                UserId:vm.UserId,
                SearchText:vm.searchQuery,
                FilterColumns:filterColumns
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              // console.log("downloadCorporateInvoiceDetail response ===>", response);
              if(response && response.fileUrl){
                // console.log("vm ===>",vm);          
                vm.downloadFileFromURL(response.fileUrl,'Detail')
                vm.$store.dispatch("toastr", {
                  type: "info",
                  header: "Information!",
                  message: "Exporting invoice Details to" + "Excel "
                });
      
              }
            }
          }
        });
      },
      exportToDoc(param){
        let vm = this;

        vm.$store.dispatch("dataRequestHandler", {
          key: "invoiceDoc",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
            }
          }
        });
      },
      exportToExcelOrPdf(param) {
        let vm = this;
        // creating a dynamic form to send values to backend route. More DOM elements can be added here //
        var form = document.createElement("form");
        var filename = document.createElement("input");
        var modulename = document.createElement("input");
        var columnList = document.createElement("input");
        var startDate = document.createElement("input");
        var endDate = document.createElement("input");
        var PropertyId = document.createElement("input");
        var UnitClassId = document.createElement("input");
        var resSourceID = document.createElement("input");
        var statusId = document.createElement("input");
        var paymentStatus = document.createElement("input");
        var ledgeraccountId = document.createElement("input");
        var groupBy = document.createElement("input");
        var dateType = document.createElement("input");
        var token = document.createElement("input");
        var Source = document.createElement("input");
        var SourceId = document.createElement("input");
        var format = document.createElement("input");

        form.method = "POST";
        form.action = this.$store.state.reportHttpUrl + "/exportToExcel";
        filename.value =
          vm.reportType + "Reports -" + moment().format("YYYY MM DD");

        filename.name = "filename";
        filename.hidden = true;
        form.appendChild(filename);

        form.appendChild;

        modulename.value = vm.reportType + "Reports";
        modulename.name = "modulename";
        modulename.hidden = true;

        columnList.value = JSON.stringify(vm.headerColumnList);
        columnList.name = "columnList";
        columnList.hidden = true;

        startDate.value = moment(vm.startDate).format("YYYY-MM-DD");
        startDate.name = "startDate";
        startDate.hidden = true;

        endDate.value = moment(vm.endDate).format("YYYY-MM-DD");
        endDate.name = "endDate";
        endDate.hidden = true;

        PropertyId.value = vm.PropertyId.join();
        PropertyId.name = "PropertyId";
        PropertyId.hidden = true;

        UnitClassId.value = vm.UnitClassId.join();
        UnitClassId.name = "UnitClassId";
        UnitClassId.hidden = true;

        resSourceID.value = vm.sourceID.join();
        resSourceID.name = "resSourceID";
        resSourceID.hidden = true;

        statusId.value = vm.statusId.join();
        statusId.name = "statusId";
        statusId.hidden = true;

        paymentStatus.value = vm.paymentStatus.join();
        paymentStatus.name = "paymentStatus";
        paymentStatus.hidden = true;

        ledgeraccountId.value = vm.ledgeraccountId.join();
        ledgeraccountId.name = "ledgeraccountId";
        ledgeraccountId.hidden = true;

        groupBy.value = vm.groupBy;
        groupBy.name = "groupBy";
        groupBy.hidden = true;

        let type = 1;
        if (vm.dateType == "paymentDate") {
          type = 1;
        } else if (vm.dateType == "stayDate") {
          type = 2;
        } else if (vm.dateType == "folioDate") {
          type = 1;
        } else if (vm.dateType == "arrivedOn") {
          type = 2;
        } else if (vm.dateType == "bookedOn") {
          type = 3;
        }
        dateType.value = type;
        dateType.name = "dateType";
        dateType.hidden = true;

        token.value = window.localStorage.getItem("rttoken");
        token.name = "token";
        token.hidden = true;

        Source.value = "Web";
        Source.name = "Source";
        Source.hidden = true;

        SourceId.value = window.location.hostname;
        SourceId.name = "SourceId";
        SourceId.hidden = true;

        format.value = param.toString();
        format.name = "format";
        format.hidden = true;

        form.appendChild(modulename);
        form.appendChild(columnList);
        form.appendChild(startDate);
        form.appendChild(endDate);
        form.appendChild(PropertyId);
        form.appendChild(UnitClassId);
        form.appendChild(resSourceID);
        form.appendChild(statusId);
        form.appendChild(paymentStatus);
        form.appendChild(ledgeraccountId);
        form.appendChild(groupBy);
        form.appendChild(dateType);
        form.appendChild(SourceId);
        form.appendChild(Source);
        form.appendChild(token);
        form.appendChild(format);
        // document.body.appendChild(systemParams);

        document.body.appendChild(form);
        form.submit();
        vm.$store.dispatch("toastr", {
          type: "info",
          header: "Information!",
          message: "Exporting Data To" + " " + param
        });
      },
      onBtExport() {
        var params = {
          fileName: this.reportType + " Reports",
          sheetName: this.reportType + " Reports"
        };
        params.processCellCallback = function (params) {
          // if (params.value && params.value.toUpperCase) {
          //   return params.value.toUpperCase();
          // } else {
          return params.value;
          // }
        };
        params.processHeaderCallback = function (params) {
          return params.column.getColDef().headerName.toUpperCase();
        };
        this.gridApi.exportDataAsExcel(params);
      },
      selectProperty(property, e) {
        let vm = this;

        if (e.target.checked) {
          vm.PropertyId.push(property.PropertyId);
        } else {
          let propertyIndex = vm.PropertyId.indexOf(property.PropertyId);
          console.log(propertyIndex);
          if (propertyIndex >= 0) {
            vm.PropertyId.splice(propertyIndex, 1);
          }
        }
        console.log("vm.PropertyId", vm.PropertyId);
        vm.GetUnitClasssListBySearchText();
      },
      selectUnitClass(UnitClass, e) {
        let vm = this;

        if (e.target.checked) {
          vm.UnitClassId.push(UnitClass.UnitClassId);
        } else {
          let UnitClassIndex = vm.UnitClassId.indexOf(UnitClass.UnitClassId);
          console.log(UnitClassIndex);
          if (UnitClassIndex >= 0) {
            vm.UnitClassId.splice(UnitClassIndex, 1);
          }
        }
      },
      selectSource(source, e) {
        let vm = this;

        if (e.target.checked) {
          vm.sourceID.push(source.sourceID);
        } else {
          let sourceIndex = vm.sourceID.indexOf(source.sourceID);
          console.log(sourceIndex);
          if (sourceIndex >= 0) {
            vm.sourceID.splice(sourceIndex, 1);
          }
        }
      },
      selectStatus(status, e) {
        let vm = this;

        if (e.target.checked) {
          vm.statusId.push(status.StatusId);
        } else {
          let statusIndex = vm.statusId.indexOf(status.StatusId);
          console.log(statusIndex);
          if (statusIndex >= 0) {
            vm.statusId.splice(statusIndex, 1);
          }
        }
      },
      selectledgeraccount(ledgeraccount, e) {
        let vm = this;

        if (e.target.checked) {
          vm.ledgeraccountId.push(ledgeraccount.ledgerAccountName);
        } else {
          let ledgeraccountIndex = vm.ledgeraccountId.indexOf(
            ledgeraccount.ledgerAccountName
          );
          console.log(ledgeraccountIndex);
          if (ledgeraccountIndex >= 0) {
            vm.ledgeraccountId.splice(ledgeraccountIndex, 1);
          }
        }
      },
      selectPaymentStatus(paymentStatus, e) {
        let vm = this;

        if (e.target.checked) {
          vm.paymentStatus.push(paymentStatus);
        } else {
          let paymentStatusIndex = vm.paymentStatus.indexOf(paymentStatus);
          console.log(paymentStatusIndex);
          if (paymentStatusIndex >= 0) {
            vm.paymentStatus.splice(paymentStatusIndex, 1);
          }
        }
      },
      showFilterByType(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "property") {
            vm.getPropertiesBySearchText();
            // }
            $("#propertyDropDown").show();
          } else if (filterCol == "UnitClass") {
            vm.GetUnitClasssListBySearchText();
            $("#UnitClassDropDown").show();
          } else if (filterCol == "source") {
            vm.getSourceListBySearchText();
            $("#sourceDropDown").show();
          }
        }, 10);
      },
      showFilterByTypein(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "property") {
            vm.getPropertiesBySearchText1();
            $("#propertyDropDown").show();
          } else if (filterCol == "unitName1") {
            vm.getUnitNamesBySearchText1();
            $("#UnitClassDropDown").show();
          } else if (filterCol == "status") {
            $("#statusDropDown").show();
          }
        }, 10);
      },
      addPropertyToFilter(property) {
        let vm = this;
        vm.PropertyId.push(property.PropertyId);
        vm.filteredProperties.push(property);
      },
      removePropertyFromFilter(property, e) {
        let vm = this;
        let propertyIndex = vm.PropertyId.indexOf(property.PropertyId);
        console.log(propertyIndex);
        if (propertyIndex >= 0) {
          vm.PropertyId.splice(propertyIndex, 1);
        }
        let Indexproperty = vm.filteredProperties.indexOf(property);
        if (Indexproperty >= 0) {
          vm.filteredProperties.splice(Indexproperty, 1);
        }
      },
      lblT() {
        let vm = this;
        let cw = this.$refs.reportSummaryCard.clientWidth;
        let cal = (cw / 100) * 30;

        let obj = {
          "font-size": cal + "%"
        };
        vm.lblTxt = obj;

        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", cw);
      },
      symbolText() {
        let vm = this;
        let cw = this.$refs.reportSummaryCard.clientWidth;
        let cal = (cw / 100) * 25;

        let obj = {
          "font-size": cal + "%"
        };
        vm.symbol = obj;

        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", cw);
      },
      valT() {
        let vm = this;
        let cw = this.$refs.reportSummaryCard.clientWidth;
        let cal = (cw / 100) * 57;

        let obj = {
          "font-size": cal + "%"
        };
        vm.valTxt = obj;

        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@", cw);
      },
      GetLedgeraccountlist() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetLedgeraccountlist",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.ledgeraccountlist.splice(
                0,
                vm.ledgeraccountlist.length,
                ...response[0]
              );
            }
          }
        });
      },
      GetPaymentstatusList() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPaymentstatusList",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.paymentStatusList.splice(
                0,
                vm.paymentStatusList.length,
                ...response[0]
              );
            }
          }
        });
      },
      GetUserEntitlementsAndDefaultProperty() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUserEntitlementsAndDefaultProperty",
          params: {
            ModuleAction: "GetUserEntitlementsAndDefaultProperty"
          },
          callback: function (err, response) {
            if (err) {
              console.log("GetUserEntitlementsAndDefaultProperty", err);
              return;
            }
            if (response) {
              console.log(
                "response in GetUserEntitlementsAndDefaultProperty",
                response
              );
              vm.userEntitlementList = response.userEntitlementList;
              // vm.UserProperties = response.properties;
              vm.getReportList();
              // vm.fncTestHousekeepingStatus();
              // vm.DefaultProperty = response.defaultPropertyId;
            }
          }
        });
      },
      getReportList() {
        let vm = this;
        if (
          this.userEntitlementList.hasOwnProperty("fncFolioReports") &&
          this.userEntitlementList.fncFolioReports.isAssigned == 1 &&
          (this.userEntitlementList.hasOwnProperty("fncPaymentsReports") &&
            this.userEntitlementList.fncPaymentsReports.isAssigned == 1)
        ) {
          this.reportType = "Sales";
          this.Get_SalesReport(this.reportType);
        } else if (
          this.userEntitlementList.hasOwnProperty("fncFolioReports") &&
          this.userEntitlementList.fncFolioReports.isAssigned == 1
        ) {
          this.reportType = "Sales";
          vm.Get_SalesReport(vm.reportType);
        } else if (
          this.userEntitlementList.hasOwnProperty("fncPaymentsReports") &&
          this.userEntitlementList.fncPaymentsReports.isAssigned == 1
        ) {
          this.reportType = "Payments";
          this.GetPaymentdetails_report(this.reportType);
        } else {
          this.reportType = null;
        }
      },
      getInvoiceList() {
        let vm=this;
        vm.loading = false;
        vm.loadingInvoiceList = true;
        vm.$store.dispatch("dataRequestHandler", {
              key: "getInvoiceDetails",
               params: {
                ClientId: vm.ClientId,
                UserId:vm.UserId,
                SearchText:vm.searchQuery
               },
               callback: function (err, response) {
                 if (response) {
                  vm.getItemDetails(response.recordsets[0])
                  vm.getCardDetails(response.recordsets[1] )
                  vm.getStatusNames(response.recordsets[2])
                  // vm.getPropertyNames(response.recordsets[4])
                  // vm.getUnitNames(response.recordsets[4])
                  vm.selectedItemCount= 0
                  vm.selectedAction="Actions";
                  vm.selectedItems = [];
                  vm.loading = false;
                  vm.loadingInvoiceList = false;
                  vm.selectedAll=false
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    message: "Corporate Invoices reports rendered successfully",
                    header: ""
                  });
                }
               },
        });
      }, 
      getCardDetails(data){
          // console.log("data========get card details",data)
          if (data && data.length > 0) { // Check if data is not empty and contains at least one object
          const { Total, Payments, Due, Count, OverDue } = data[0]; // Destructure properties from the first object in the array
          this.total=Total;
          this.payments= Payments;
          this.count=Count;
          this.due=Due;
          this.overDue=OverDue;
          } else {
            console.error("No data found or empty array.");
          }
      },
      getItemDetails(data){ 
        const filteredData = data.filter(item => item.ledgerAccountName == "Balance Transfer").reverse()
        this.InvoiceDetailsData = filteredData;
      },
      getStatusNames(data){
        if(data && data.length > 0){
          this.filterObjForInvoice.statusList=[]
          const uniqueStatusNames = data.filter((item, index, self) =>
            index === self.findIndex(t => t.folioStatusID === item.folioStatusID) && !this.viewSaveObject.statusList.some(previtem => previtem.folioStatusID === item.folioStatusID)
            );
            const uniqueStatusNames1 = data.filter((item, index, self) =>
            index === self.findIndex(t => t.folioStatusID === item.folioStatusID && !["Closed", "Overdue"].includes(t.folioStatusName) ))
        
            this.filterObjForInvoice.statusList.push(...uniqueStatusNames);
            this.invoiceStatusList=uniqueStatusNames1
        }    
      },
      clearSearch(){
        // this.loading = true;
            this.$nextTick(() => {
        this.searchQuery = '';
        this.searchInvoiceList();
        // this.loading = false;
        });
      },
      toggleSelection(item) {
        // console.log("toggleSelection",item)
        const index = this.selectedItems.indexOf(item);
        if (index === -1) {
          this.selectedItems.push(item);
        } else {
          this.selectedItems.splice(index, 1);
        }
        this.selectedItemCount = this.selectedItems.length;
      },
      selectAllItems(event) {
        const checked = event.target.checked;
        // console.log("selectAllItems",event)
        // Determine which array to use based on search status
        const itemsArray = this.InvoiceDetailsData;
        // Ensure itemsArray is defined
        if (itemsArray && itemsArray.length > 0) {
          // Set isvoided property of each item to match the checked status
          itemsArray.forEach(item => {
            item.isSlected = checked;        
          });
          // Update selectedItems array
          this.selectedItems = checked ? [...itemsArray] : [];
          this.selectedItemCount = checked ? this.selectedItems.length : 0;
          // console.log("this.selectedItems",this.selectedItems)
          } else {
          // Clear selectedItems array if itemsArray is empty or undefined
          this.selectedItems = [];
          this.selectedItemCount = 0;
          console.error("Items array is empty or undefined.");
          }
      },
      closeFilter() {
            let vm = this;
            vm.showInvocieDetail = false;
            vm.selectedInvoiceItem = {};
            vm.toggleFilterPanel = false;
            vm.showPropertyList= false,
            vm.showunitList= false,
            vm.showunitTypeList=false
            vm.showsourceList= false,
            vm.showunitNameList=false,
            vm.showstatusList= false,
            vm.showtagList= false
            if (vm.filterObj.Columns.length >= 1) {
              let result = vm.filterObj.Columns.filter(col => col.value != null);

              let result2 = vm.filterObj.Columns.filter(col => col.arrText.length > 0);
              vm.filterObj.Columns = result.concat(result2);
            }
      },
      getUserProfile() {
        let self = this;
         self.$store.dispatch("dataRequestHandler", {
              key: "GetUserProfile",
               params: {},
               callback: function (err, response) {
                 if (response) {
                self.ClientId=response[0][0].ClientId
                self.UserId=response[0][0].UserId
                }
               },
        });
      },
      deletePropertyFromFilterin(propertyObj, event) {
           let vm = this;
        var index = vm.filterPropertyListForInvoice.indexOf(propertyObj);
        if (index > -1) {
          vm.filterPropertyListForInvoice.splice(index, 1);
        }
        vm.propertyListForInvoice.push(propertyObj);
        vm.propertyListForInvoice = vm.propertyListForInvoice.sort((a,b) => a.PropertyName.localeCompare(b.PropertyName))
        if (event)
          event.stopPropagation();
      },
      showpropertyFnc() {
        this.showPropertyList = true;
      },
      showunitNameFnc() {
        this.showunitNameList = true;
      },
      showstatusFnc(){
        this.showstatusList= true
      },
      clearAllFilters() {
        this.showPropertyList= false;
        this.showunitList= false;
        this.showunitTypeList = false;
        this.showunitNameList=false;
        this.showstatusList= false;
        this.filterObjForInvoice.propertyNamesAndId = [];
        this.filterObjForInvoice.filtObjPropertyNamesAndId = [];
        this.filterObjForInvoice.unitNamesAndId = [];
        this.filterObjForInvoice.filtObjUnitNamesAndId = [];
        this.filterObjForInvoice.filterstatusList=[];
        this.filterObjForInvoice.startCreatedDate = null;
        this.filterObjForInvoice.endCreatedDate = null;
        this.filterObjForInvoice.startDueDate = null;
        this.filterObjForInvoice.endDueDate = null;
        this.showClearFilter=false;
        this.viewSaveObject= {
          properties: [],
          UnitClasses: [],
          UnitTypes:[],
          sources: [],
          units: [],
          statusList: [],
          stayStartDate:null,
          stayEndDate:null
        },
        this.getInvoiceList()
      },
      updateFilterStayStartDate(key, dateObj, objectPassedToParent) {
          this.filterObj.startCreatedDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
      },
      updateFilterStayEndDate(key, dateObj, objectPassedToParent) {
          this.filterObj.endCreatedDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
      },
      //update function for date-range-picker for stay dates
      updateCreateDateValues(value) {
        this.filterObjForInvoice.startCreatedDate = moment(value.startDate).format('DD MMM YYYY')
        this.filterObjForInvoice.endCreatedDate = moment(value.endDate).format('DD MMM YYYY')
      },
      updateDueDateValues(value){
        this.filterObjForInvoice.startDueDate=moment(value.startDate).format('DD MMM YYYY')
        this.filterObjForInvoice.endDueDate=moment(value.endDate).format('DD MMM YYYY')
      },
      clearCreatedDate(){
        this.filterObjForInvoice.startCreatedDate = null;
        this.filterObjForInvoice.endCreatedDate = null;
        this.applyFilter();
      },
      clearDueDate(){
        this.filterObjForInvoice.startDueDate = null;
        this.filterObjForInvoice.endDueDate = null;
        this.applyFilter();
      },
      applyFilter() {
          this.resetFilter(); // Resetting filter state
          this.selectedItemCount= 0

          if (!this.filterObjForInvoice) return; // Exit if filter object is not present
          // console.log(this.filterUnitListForInvoice)
          // Destructuring filterObjForInvoice for easier access
          const { endCreatedDate, endDueDate, startDueDate, startCreatedDate } = this.filterObjForInvoice;
          const { filtObjUnitNamesAndId, filtObjPropertyNamesAndId, filterstatusList } = this.filterObjForInvoice;
          const unitList=this.filterUnitListForInvoice
          const propertyList=this.filterPropertyListForInvoice
          // Setting viewSaveObject properties
          this.viewSaveObject.properties = [...propertyList];
          this.viewSaveObject.UnitTypes = [...unitList];
          this.viewSaveObject.statusList = [...filterstatusList];
          this.viewSaveObject.startCreatedDate = startCreatedDate;
          this.viewSaveObject.endCreatedDate = endCreatedDate;
          this.viewSaveObject.startDueDate = startDueDate;
          this.viewSaveObject.endDueDate = endDueDate;

          // Check conditions for showing clear filter button
          if (this.viewSaveObject.properties.length >= 2 && 
              this.viewSaveObject.UnitTypes.length >= 2 && 
              this.viewSaveObject.startCreatedDate && 
              this.viewSaveObject.startDueDate) {
                  this.showClearFilter = true;
          }

          // Constructing the FilterColumns array
          const filterColumns = [
              {
                  ColumnName: "Propertyid",
                  ColumnText: propertyList.map(Property => Property.PropertyId).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "UnitID",
                  ColumnText: unitList.map(Unit => Unit.UnitId).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "FolioStatusID",
                  ColumnText: filterstatusList.map(status => status.folioStatusID).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "CreatedDate",
                  ColumnText: null,
                  StartDate: startCreatedDate,
                  EndDate: endCreatedDate
              },
              {
                  ColumnName: "Duedate",
                  ColumnText: null,
                  StartDate: startDueDate,
                  EndDate: endDueDate
              }
          ];
          let vm=this;
        vm.loading = true;
        setTimeout(()=>{
        vm.$store.dispatch("dataRequestHandler", {
              key: "getInvoiceDetails",
               params: {
                ClientId: vm.ClientId,
                UserId:vm.UserId,
                SearchText:vm.searchQuery,
                FilterColumns:filterColumns
               },
               callback: function (err, response) {
                 if (response) {
                  vm.getItemDetails(response.recordsets[0])
                  vm.getCardDetails(response.recordsets[1] )
                  vm.getStatusNames(response.recordsets[2])
                  // vm.getPropertyNames(response.recordsets[4])
                  // vm.getUnitNames(response.recordsets[4])
                  vm.selectedAction="Actions";
                            vm.selectedItemCount=0;
                            vm.selectedItems = [];
                  vm.selectedAll=false 
                  vm.loading = false;
                  vm.$store.dispatch("toastr", {
                            type: "success",
                            message: "Corporate invoices rendered successfully",
                            header: ""
                          });
                }
               },
        });
        },1000)
      },

      resetFilter() {
          this.toggleFilterPanel = false;
      },
      addPropertyToFilterin(propertyObj) {
        // console.log("====================>addPropertyToFilterin")
        this.propertyId.push(propertyObj.PropertyId);
        let vm = this;
        vm.filterPropertyListForInvoice.push(propertyObj);
        vm.filterSearchPropertyText1 = null;
        var index = vm.propertyListForInvoice.indexOf(propertyObj);
        // console.log("addPropertyToFilterin",index)
        if (index > -1) {
          vm.propertyListForInvoice.splice(index, 1);
        }
        vm.filterPropertyListForInvoice = vm.filterPropertyListForInvoice.sort((a,b) => a.PropertyName.localeCompare(b.PropertyName))
        // vm.GetUnitClasssListBySearchText();
        vm.showPropertyList = false;
        vm.getUnitNamesBySearchText1();
        vm.selectedFilterColumn = null;
        },
      addUnitToFilterin(unitObj) {
        this.filterUnitListForInvoice.push(unitObj);
        this.filterSearchUnitNameText1 = null;
          var index = this.unitListForInvoice.indexOf(unitObj);
          if (index > -1) {
            this.unitListForInvoice.splice(index, 1);
          }
        this.filterUnitListForInvoice = this.filterUnitListForInvoice.sort((a,b) => a.UnitName.localeCompare(b.UnitName))
        this.showunitNameList = false;
        this.selectedFilterColumn = null;
        },
      addStatusToFilterin(obj){
          this.filterObjForInvoice.filterstatusList.push(obj);
          this.filterSearchstatusText = '';
          var index=this.filterObjForInvoice.statusList.indexOf(obj);
          if(index > -1){
            this.filterObjForInvoice.statusList.splice(index,1);
          }
          this.filterObjForInvoice.filterstatusList = this.filterObjForInvoice.filterstatusList.sort((a,b) => a.folioStatusName.localeCompare(b.folioStatusName))
          this.showstatusList=false;
          this.selectedFilterColumn=null;
      },
      removePropertyFromFilterin(index, propObj) {
            this.deletePropertyFromFilterin(propObj);
            this.viewSaveObject.properties.splice(index, 1);
        this.applyFilter();
      },
      removeAllPropertiesFromFilterin() {
        this.filterPropertyListForInvoice = [];
        this.viewSaveObject.properties = [];
        this.showClearFilter = false;
        this.applyFilter();
      },
      removeUnitFromFilterin(index, propObj) {
       this.deleteUnitFromFilterin(propObj);
       this.viewSaveObject.UnitTypes.splice(index,1)
       this.applyFilter();
      },
      removeAllUnitsFromFilterin() {
        this.filterUnitListForInvoice = [];
        this.viewSaveObject.UnitTypes = [];
        this.showClearFilter = false;
        this.applyFilter();
      },
      removeStatusFromFilterin(obj,event){
        const index =this.filterObjForInvoice.filterstatusList.findIndex(s => s.ItemStatusID === obj.ItemStatusID);
        if(index !== -1){
          this.filterObjForInvoice.filterstatusList.splice(index,1);
          if(this.filterObjForInvoice.filterstatusList.length <=1){
            this.showstatusList = false;
          }
          this.applyFilter();
        }
        if (event) {
          event.stopPropagation();
        }
      },
      removeAllStatusFromFilterin(){
        this.filterObjForInvoice.filterstatusList=[];
        this.viewSaveObject.statusList=[];
        this.showClearFilter = false;
        this.applyFilter();
      },
      deleteUnitFromFilterin(unitObj, event){
        const index = this.filterUnitListForInvoice.findIndex(p => p.UnitId === unitObj.UnitId);
        if (index !== -1) {
        this.filterUnitListForInvoice.splice(index, 1);
        }
        this.unitListForInvoice.push(unitObj)
        this.unitListForInvoice = this.unitListForInvoice.sort((a,b) => a.UnitName.localeCompare(b.UnitName))
        if (event) {
        event.stopPropagation();
        }
      },
      deleteStatusFromFilterin(obj,event){
        const index =this.filterObjForInvoice.filterstatusList.findIndex(s => s.folioStatusID === obj.folioStatusID);
        if(index !== -1){
          this.filterObjForInvoice.filterstatusList.splice(index,1);
        }
        this.filterObjForInvoice.statusList.push(obj)
        this.filterObjForInvoice.statusList = this.filterObjForInvoice.statusList.sort((a,b) => a.folioStatusName.localeCompare(b.folioStatusName))
        if (event) {
        event.stopPropagation();
        }
      },
      addUnitToFilter(unitObj) {
        let vm = this;
        vm.filterObj.Units.push(unitObj);
        vm.filterSearchUnitNameText = null;
        var index = vm.unitList.indexOf(unitObj);

        if (index > -1) {
          vm.unitList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
      },
      handleSelectedActionChange(selectedValue) {
        this.selectedAction = selectedValue;

        const statusMap = {
            "Voided": 4,
            "Draft": 1,
            "In review": 2,
            "Posted": 5,
            "Open": 6,
            "Closed": 3
        };

        const id = statusMap[selectedValue];
        
        // Check if any selected items already have the same status
        const sameStatusItems = this.selectedItems.every(item => item.FolioStatusId === id);
        if (sameStatusItems) {
            this.$store.dispatch("toastr", {
                type: "warning",
                message: "Please select an alternative status",
                header: "Warning!"
            });
            return; // Exit the function early
        }
        if (selectedValue === "Posted") {
            const selectedItem = this.selectedItems[0];
            const hasUnsyncedItems = selectedItem && selectedItem.IsIntegrated;
            
            if (this.selectedItems.length == 1 && !hasUnsyncedItems) {
                this.$store.dispatch("toastr", {
                    type: "warning",
                    message: "This unit is not mapped to Quickbooks. Please check unit mapping to proceed",
                    header: "Warning!"
                });
                return;
            } else if (this.selectedItems.length > 1 && this.selectedItems.some(item => item.IsIntegrated == false)) {
                this.$store.dispatch("toastr", {
                    type: "warning",
                    message: "This units is not mapped to Quickbooks. Please check unit mapping to proceed",
                    header: "Warning!"
                });
                return;
            }
        }


        switch (selectedValue) {
          
            case "Voided":
                this.processItems(id, [1, 2, 5], 4);
                break;
            case "Draft":
                this.processItems(id, [2], 1);
                break;
            case "In review":
                this.processItems(id, [1], 2);
                break;
            case "Posted":
                this.processItems(id, [1, 2], 5);
                break;
            case "Open":
                this.processItems(id, [5], 6);
                break;
            // Add more cases if necessary
            default:
                break;
        }
      },

      processItems(id, allowedStatusIds, newStatusId) {
          const filteredItems = this.getFilteredItems(id, allowedStatusIds);
          if (filteredItems.length > 0) {
              this.postFolioStatusUpdate(id, filteredItems, newStatusId);
          }
      },
      getFilteredItems(id, allowedStatusIds) {
          return this.selectedItems.filter(item => item.FolioStatusId !== id && allowedStatusIds.includes(item.FolioStatusId));
      },
      postFolioStatusUpdate(id, filteredItems, newStatusId) {
          const folioIds = filteredItems.map(item => item.FolioId).join(',');
          let vm = this;
          vm.loading = true;
          vm.isLoading = true;
          vm.$store.dispatch("dataRequestHandler", {
              key: "getFoliStatusUpdate",
              params: {
                  FolioIds: folioIds,
                  ClientId: vm.ClientId,
                  NewFolioStatusId: newStatusId,
                  filteredItems: filteredItems
              },
              callback: function (err, response) {
                  if (response) {
                    if (response.msg) {
                        // Show toast for message sent to QuickBooks
                        vm.$store.dispatch("toastr", {
                            type: "success",
                            message: "Sent to QuickBooks",
                            header: "Success!"
                        });
                      }
                    // } else {
                    //     // Show toast for status changed successfully after 1000 ms delay
                    //     setTimeout(() => {
                    //         vm.$store.dispatch("toastr", {
                    //             type: "success",
                    //             message: "Status changed successfully",
                    //             header: "Success!"
                    //         });
                    //     }, 1000);
                    // }
                      const filterColumns = vm.generateFilterColumns();
                      setTimeout(() => {
                          vm.$store.dispatch("dataRequestHandler", {
                              key: "getInvoiceDetails",
                              params: {
                                  ClientId: vm.ClientId,
                                  UserId: vm.UserId,
                                  SearchText: vm.searchQuery,
                                  FilterColumns: filterColumns
                              },
                              callback: function (err, response) {
                                  if (response) {
                                      vm.handleSuccessfulResponse(response);
                                  }
                              }
                          });
                      }, 4000);
                  }
              }
          });
      },
      generateFilterColumns() {
          return [
          {
                  ColumnName: "Propertyid",
                  ColumnText: this.viewSaveObject.properties.map(Property => Property.PropertyId).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "UnitID",
                  ColumnText: this.viewSaveObject.UnitTypes.map(Unit => Unit.UnitId).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "FolioStatusID",
                  ColumnText: this.viewSaveObject.statusList.map(status => status.folioStatusID).join(','),
                  StartDate: null,
                  EndDate: null
              },
              {
                  ColumnName: "CreatedDate",
                  ColumnText: null,
                  StartDate: this.viewSaveObject.startCreatedDate,
                  EndDate: this.viewSaveObject.endCreatedDate
              },
              {
                  ColumnName: "Duedate",
                  ColumnText: null,
                  StartDate: this.viewSaveObject.startDueDate,
                  EndDate: this.viewSaveObject.endDueDate
              }
          ];
      },
      handleSuccessfulResponse(response) {
          this.getItemDetails(response.recordsets[0]);
          this.getCardDetails(response.recordsets[1]);
          this.getStatusNames(response.recordsets[2]);
          this.loading = false;
          this.isLoading = false;
          this.resetSelection();
          this.$store.dispatch("toastr", {
              type: "success",
              message: "Status changed successfully",
              header: "Success!"
          });
      },
      resetSelection() {
          this.selectedAction = "Actions";
          this.selectedItemCount = 0;
          this.selectedItems = [];
          this.selectedAll = false;
      },
      searchInvoiceList(){
        let vm=this
        const filterColumns = [
                      {
                          ColumnName: "Propertyid",
                          ColumnText: vm.viewSaveObject.properties.map(Property => Property.PropertyId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "UnitID",
                          ColumnText: vm.viewSaveObject.UnitTypes.map(Unit => Unit.UnitId).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "FolioStatusID",
                          ColumnText: vm.viewSaveObject.statusList.map(status => status.folioStatusID).join(','),
                          StartDate: null,
                          EndDate: null
                      },
                      {
                          ColumnName: "CreatedDate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startCreatedDate,
                          EndDate: vm.viewSaveObject.endCreatedDate
                      },
                      {
                          ColumnName: "Duedate",
                          ColumnText: null,
                          StartDate: vm.viewSaveObject.startDueDate,
                          EndDate: vm.viewSaveObject.endDueDate
                      }
                  ];
                  setTimeout(()=>{
                    vm.loading=true
                  vm.$store.dispatch("dataRequestHandler", {
                        key: "getInvoiceDetails",
                        params: {
                          ClientId: vm.ClientId,
                          UserId:vm.UserId,
                          SearchText:vm.searchQuery,
                          FilterColumns:filterColumns
                        },
                        callback: function (err, response) {
                          
                          if (response) {
                            // console.log("response when searching data",response)
                            vm.getItemDetails(response.recordsets[0])
                            vm.getCardDetails(response.recordsets[1] )
                            vm.getStatusNames(response.recordsets[2])
                            vm.isLoading=false
                            vm.selectedAction="Actions";
                            vm.selectedItemCount=0;
                            vm.selectedItems = [];
                            vm.selectedAll=false;
                            vm.loading = false;
                            vm.$store.dispatch("toastr", {
                            type: "success",
                            message: "Corporate invoices rendered successfully",
                            header: ""
                          });
                          }
                        },
                    });
                  },1000)          
      },
      pdfDownload() {
        const items=this.selectedItems[0];
        this.selectedInvoiceObj=items;
        this.ReservationId=items.ReservationId
        this.clientId=items.ClientId;
        this.companyProfileId=items.CompanyProfileId
        const parentComp = 'guestProfile'

        // console.log("thimmapp",items)
        // console.log("thimmappa1",this.additionalEmails.Emailaddress) 
                const {
                    actualMyValue,
                    // selectedLedger,
                    apiUrl,
                    // DetailedOrConsolidated,
                    guestInfo,
                    // companyProfileId,
                    // clientId,
                    
                    balanceTransferDetails,
                    corporateDetails,
                    corporateEmail,
                    corporatePhoneNo,
                    totalBalanceTransfer,
                    selectedInvoiceObj,
                    isMasterFolioAvailable,
                } = this;
                // console.log("guestInfo==================>",guestInfo)
                const additionalCompanyDetails = {
                    createdTransferDate: balanceTransferDetails ? balanceTransferDetails[0].CreatedDate : null,
                    invoiceNo: balanceTransferDetails && balanceTransferDetails[0].InvoiceNo && balanceTransferDetails[0].InvoiceNo != null ? balanceTransferDetails[0].InvoiceNo : '',
                    corporateAddress: guestInfo.CompanyProfileAddress1,
                    corporateCity: guestInfo.CompanyProfileCity,
                    corporateState: guestInfo.CompanyProfileState,
                    corporateCountry: guestInfo.CompanyProfileCountryName,
                    postalCode: guestInfo.CompanyPostalCode,
                    companyName: guestInfo.CompanyProfileName,
                    companyEmail: guestInfo.CompanyEmail ? guestInfo.CompanyEmail :'' ,
                    companyPhnNo: guestInfo.CompanyPhoneNumber ? guestInfo.CompanyPhoneNumber :''
                }

                const form = document.createElement("form");

                const createInput = (name, value, hidden = true) => {
                    const input = document.createElement("input");
                    input.name = name;
                    input.value = value;
                    input.hidden = hidden;
                    return input;
                };

                const appendInput = (name, value, hidden = true) => {
                    form.appendChild(createInput(name, value, hidden));
                };

                appendInput("ReservationId",  this.ReservationId);
                appendInput("ClientId", this.clientId);
                appendInput("companyProfileId", this.companyProfileId);
                appendInput("imgUrl", `${apiUrl}/downloadImage/`);
                // appendInput("ledgerAccountId", selectedLedger?.ledgerAccountID || null);
                appendInput("ledgerAccountId", null);
                // appendInput("Amount", selectedLedger?.defaultAmount || selectedLedger?.TaxAmount || null);
                appendInput("Amount",  null);
                // appendInput("DateEffective", selectedLedger ? moment(selectedLedger.dateEffective).format("YYYY-MM-DD") : null);
                appendInput("DateEffective", null);
                // appendInput("IsFolioEdit", selectedLedger && selectedLedger.dateEffective != null ? 1 : 0);
                appendInput("IsFolioEdit", 0)
                // appendInput("DetailedOrConsolidated", DetailedOrConsolidated);
                appendInput("DetailedOrConsolidated", 2);
                appendInput("ShowTaxdetailsonDetailedInvoice", guestInfo.ShowTaxdetailsonDetailedInvoice);
                appendInput("ShowPolicyonDetailedInvoice", guestInfo.ShowPolicyonDetailedInvoice);
                appendInput("invoiceType", parentComp);
                appendInput("companyDetails", JSON.stringify(additionalCompanyDetails));
                appendInput("balanceTransferDetails", JSON.stringify(balanceTransferDetails));
                appendInput("totalBalanceTransfer", JSON.stringify(selectedInvoiceObj));
                appendInput("isMasterFolioAvailable", isMasterFolioAvailable);
                appendInput("folioId", selectedInvoiceObj.FolioId);
                form.method = "POST";
                form.action = `${this.$store.state.reportHttpUrl}/FolioInvoice1`;
                document.body.appendChild(form);
                form.submit();
            },
            wordDownload() {
        const items=this.selectedItems[0];
        this.selectedInvoiceObj=items;
        this.ReservationId=items.ReservationId
        this.clientId=items.ClientId;
        this.companyProfileId=items.CompanyProfileId
        const parentComp = 'guestProfile'

        // console.log("thimmapp",items)
        // console.log("thimmappa1",this.additionalEmails.Emailaddress) 
                const {
                    actualMyValue,
                    // selectedLedger,
                    apiUrl,
                    // DetailedOrConsolidated,
                    guestInfo,
                    // companyProfileId,
                    // clientId,
                    
                    balanceTransferDetails,
                    corporateDetails,
                    corporateEmail,
                    corporatePhoneNo,
                    totalBalanceTransfer,
                    selectedInvoiceObj,
                    isMasterFolioAvailable,
                } = this;
                const additionalCompanyDetails = {
                    createdTransferDate: balanceTransferDetails ? balanceTransferDetails[0].CreatedDate : null,
                    invoiceNo: balanceTransferDetails && balanceTransferDetails[0].QuickbookInvoiceNo && balanceTransferDetails[0].QuickbookInvoiceNo != null ? balanceTransferDetails[0].QuickbookInvoiceNo : balanceTransferDetails[0].InvoiceNo,
                    corporateAddress: guestInfo.CompanyProfileAddress1,
                    corporateCity: guestInfo.CompanyProfileCity,
                    corporateState: guestInfo.CompanyProfileState,
                    corporateCountry: guestInfo.CompanyProfileCountryName,
                    postalCode: guestInfo.CompanyPostalCode,
                    companyName: guestInfo.CompanyProfileName,
                    companyEmail: guestInfo.CompanyEmail ? guestInfo.CompanyEmail :'' ,
                    companyPhnNo: guestInfo.CompanyPhoneNumber ? guestInfo.CompanyPhoneNumber :''
                }

                const form = document.createElement("form");

                const createInput = (name, value, hidden = true) => {
                    const input = document.createElement("input");
                    input.name = name;
                    input.value = value;
                    input.hidden = hidden;
                    return input;
                };

                const appendInput = (name, value, hidden = true) => {
                    form.appendChild(createInput(name, value, hidden));
                };

                appendInput("ReservationId",  this.ReservationId);
                appendInput("ClientId", this.clientId);
                appendInput("companyProfileId", this.companyProfileId);
                appendInput("imgUrl", `${apiUrl}/downloadImage/`);
                // appendInput("ledgerAccountId", selectedLedger?.ledgerAccountID || null);
                appendInput("ledgerAccountId", null);
                // appendInput("Amount", selectedLedger?.defaultAmount || selectedLedger?.TaxAmount || null);
                appendInput("Amount",  null);
                // appendInput("DateEffective", selectedLedger ? moment(selectedLedger.dateEffective).format("YYYY-MM-DD") : null);
                appendInput("DateEffective", null);
                // appendInput("IsFolioEdit", selectedLedger && selectedLedger.dateEffective != null ? 1 : 0);
                appendInput("IsFolioEdit", 0)
                // appendInput("DetailedOrConsolidated", DetailedOrConsolidated);
                appendInput("DetailedOrConsolidated", 2);
                appendInput("ShowTaxdetailsonDetailedInvoice", guestInfo.ShowTaxdetailsonDetailedInvoice);
                appendInput("ShowPolicyonDetailedInvoice", guestInfo.ShowPolicyonDetailedInvoice);
                appendInput("invoiceType", parentComp);
                appendInput("companyDetails", JSON.stringify(additionalCompanyDetails));
                appendInput("balanceTransferDetails", JSON.stringify(balanceTransferDetails));
                appendInput("totalBalanceTransfer", JSON.stringify(selectedInvoiceObj));
                appendInput("isMasterFolioAvailable", isMasterFolioAvailable);
                appendInput("folioId", selectedInvoiceObj.FolioId);
                form.method = "POST";
                form.action = `${this.$store.state.reportHttpUrl}/FolioInvoiceWord`;
                document.body.appendChild(form);
                form.submit();
            },
            pdfDownload1() {
                this.$store.dispatch("toastr", {
                  type: "info",
                  header: "Information!",
                  message: "Downloading Invoices"
                });
              
                const folioData = [];
              
                const processItem = async (item) => {
                  const parentComp = 'guestProfile';
                  try {
                    const balanceDetail = await this.getMultipleCorporateInvoiceData(item.CompanyProfileId, item.ItemId);
                    let masterFolio = balanceDetail.find(val => val.isMaster == 1);
                    const data = masterFolio ? masterFolio.isMaster : false;
                    const guestInfo = await this.getMultipleCorporateInvoiceGuestInfoData(item.ReservationId, item.CompanyProfileId);
              
                    const additionalCompanyDetails = {
                      createdTransferDate: balanceDetail[0] ? balanceDetail[0].CreatedDate : null,
                      invoiceNo: balanceDetail[0] && balanceDetail[0].InvoiceNo && balanceDetail[0].InvoiceNo != null ? balanceDetail[0].InvoiceNo : '',
                      corporateAddress: guestInfo.CompanyProfileAddress1,
                      corporateCity: guestInfo.CompanyProfileCity,
                      corporateState: guestInfo.CompanyProfileState,
                      corporateCountry: guestInfo.CompanyProfileCountryName,
                      postalCode: guestInfo.CompanyPostalCode,
                      companyName: guestInfo.CompanyProfileName,
                      companyEmail: guestInfo.CompanyEmail ? guestInfo.CompanyEmail : '',
                      companyPhnNo: guestInfo.CompanyPhoneNumber ? guestInfo.CompanyPhoneNumber : ''
                    };
              
                    const formData = {
                      ReservationId: item.ReservationId,
                      ClientId: item.ClientId,
                      companyProfileId: item.CompanyProfileId,
                      imgUrl: `${this.apiUrl}/downloadImage/`,
                      ledgerAccountId: null,
                      Amount: null,
                      DateEffective: null,
                      IsFolioEdit: 0,
                      DetailedOrConsolidated: 2,
                      ShowTaxdetailsonDetailedInvoice: guestInfo.ShowTaxdetailsonDetailedInvoice,
                      ShowPolicyonDetailedInvoice: guestInfo.ShowPolicyonDetailedInvoice,
                      invoiceType: parentComp,
                      companyDetails: additionalCompanyDetails,
                      balanceTransferDetails: balanceDetail,
                      totalBalanceTransfer: item,
                      isMasterFolioAvailable: data,
                      folioId: item.FolioId,
                    };
              
                    folioData.push(formData);
              
                  } catch (error) {
                    console.error("Error fetching invoice details:", error);
                  }
                };
              
                const processAllItemsSequentially = async () => {
                  for (const item of this.selectedItems) {
                    await processItem(item);
                  }
                };
              
                processAllItemsSequentially().then(() => {
                  axios.post(`${this.$store.state.reportHttpUrl}/FolioInvoice11`, { FolioData: folioData }, {
                    responseType: 'blob' // Ensure response is treated as a blob (binary data)
                  })
                  .then(response => {
                    // Create a temporary URL to the blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
              
                    // Create a temporary <a> element to trigger the download
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = 'Invoices.zip';
                    document.body.appendChild(a);
                    a.click();
              
                    // Cleanup
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
              
                    this.$store.dispatch("toastr", {
                      type: "success",
                      header: "Success!",
                      message: "Invoices Downloaded Successfully"
                    });
                  })
                  .catch(error => {
                    console.error('Error downloading invoices:', error);
                    this.$store.dispatch("toastr", {
                      type: "error",
                      header: "Error!",
                      message: "Failed to download invoices. Please try again."
                    });
                  });
                });
              },
 
            // pdfDownload1() {
            //   // this.isLoad = true;
            //   if(this.selectedItems.length > 100){
            //     this.$store.dispatch("toastr", {
            //       type: "warning",
            //       header: "Information!",
            //       message: "Only 100 Invoices are allowed to download"
            //     });
            //     return 
            //   }
            //   this.$store.dispatch("toastr", {
            //     type: "info",
            //     header: "Information!",
            //     message: "Downloading Invoices"
            //   });
            //     const folioData = [];
            //     Promise.all(this.selectedItems.map(async (item, index) => {
            //         const parentComp = 'guestProfile';
            //         let isMasterFolioAvailable = null
            //         try {
            //             const balanceDetail = await this.getMultipleCorporateInvoiceData(item.CompanyProfileId,item.ItemId);
            //           //  console.log("balanceDetail",balanceDetail)
            //             let masterFolio = balanceDetail.find(val => val.isMaster == 1);
            //             const data= masterFolio ? masterFolio.isMaster : false;
            //             // console.log("vm.isMasterFolioAvailable11",data)
            //                 const guestInfo = await this.getMultipleCorporateInvoiceGuestInfoData(item.ReservationId,item.CompanyProfileId)
            //             const {
            //                 apiUrl 
            //             } = this;
            //             const additionalCompanyDetails = {
            //                 createdTransferDate: balanceDetail ? balanceDetail.CreatedDate : null,
            //                 invoiceNo: balanceDetail[0] && balanceDetail[0].QuickbookInvoiceNo && balanceDetail[0].QuickbookInvoiceNo != null ? balanceDetail[0].QuickbookInvoiceNo : balanceDetail[0].InvoiceNo,
            //                 corporateAddress: guestInfo.CompanyProfileAddress1,
            //                 corporateCity: guestInfo.CompanyProfileCity,
            //                 corporateState: guestInfo.CompanyProfileState,
            //                 corporateCountry: guestInfo.CompanyProfileCountryName,
            //                 postalCode: guestInfo.CompanyPostalCode,
            //                 companyName: guestInfo.CompanyProfileName,
            //                 companyEmail: guestInfo.CompanyEmail ? guestInfo.CompanyEmail : '',
            //                 companyPhnNo: guestInfo.CompanyPhoneNumber ? guestInfo.CompanyPhoneNumber : ''
            //             };
            //         //  console.log("ggfngfjjgfn",balanceDetail && balanceDetail.QuickbookInvoiceNo && balanceDetail.QuickbookInvoiceNo != null ? balanceDetail.QuickbookInvoiceNo : balanceDetail.InvoiceNo)
            //             const formData = {
            //                 ReservationId: item.ReservationId,
            //                 ClientId: item.ClientId,
            //                 companyProfileId: item.CompanyProfileId,
            //                 imgUrl: `${apiUrl}/downloadImage/`,
            //                 ledgerAccountId: null,
            //                 Amount: null,
            //                 DateEffective: null,
            //                 IsFolioEdit: 0,
            //                 DetailedOrConsolidated: 2,
            //                 ShowTaxdetailsonDetailedInvoice: guestInfo.ShowTaxdetailsonDetailedInvoice,
            //                 ShowPolicyonDetailedInvoice: guestInfo.ShowPolicyonDetailedInvoice,
            //                 invoiceType: parentComp,
            //                 companyDetails: additionalCompanyDetails,
            //                 balanceTransferDetails: balanceDetail,
            //                 totalBalanceTransfer: item,
            //                 isMasterFolioAvailable: data,
            //                 folioId: item.FolioId,
            //             };

            //             folioData.push(formData);

            //         } catch (error) {
            //             console.error("Error fetching invoice details:", error);
            //         }
            //     })).then(() => {
            //         // After all promises are resolved, make the POST request to download ZIP file
            //         axios.post(`${this.$store.state.reportHttpUrl}/FolioInvoice11`, { FolioData: folioData }, {
            //             responseType: 'blob' // Ensure response is treated as a blob (binary data)
            //         })
            //         .then(response => {
            //             // Create a temporary URL to the blob
            //             // console.log("bulpdf response",response)
            //             const url = window.URL.createObjectURL(new Blob([response.data]));

            //             // Create a temporary <a> element to trigger the download
            //             const a = document.createElement('a');
            //             a.style.display = 'none';
            //             a.href = url;
            //             a.download = 'Invoices.zip';
            //             document.body.appendChild(a);
            //             a.click();

            //             // Cleanup
            //             window.URL.revokeObjectURL(url);
            //             document.body.removeChild(a);

                        
            //             this.$store.dispatch("toastr", {
            //             type: "success",
            //             header: "Success!",
            //             message: "Invoices Downloaded Successfully"
            //           });
            //         })
            //         .catch(error => {
            //             console.error('Error downloading invoices:', error);
            //             // Handle errors here
            //             this.$store.dispatch("toastr", {
            //                 type: "error",
            //                 header: "Error!",
            //                 message: "Failed to download invoices. Please try again."
            //             });
            //         })
            //         .finally(() => {
            //           // this.isLoad = false; // Stop loading
            //       });
            //     });
            // },
            getMultipleCorporateInvoiceData(GuestProfileId,itemId) {
            let vm = this;
                return new Promise((resolve, reject) => {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "getBalanceTransferFolioDetails",
                        params: {
                          ModuleAction: "GetBalanceTransferFolioDetails",
                          GuestProfileId: GuestProfileId,
                            itemId: itemId,
                        },
                        callback: function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                // console.log("multipleinvoiceinvoicedetail response =====>", response[0]);
                                resolve(response[0]);
                            }
                        },
                    });
                });
            },
            getMultipleCorporateInvoiceGuestInfoData(ReservationId,companyProfileId) {
                let vm = this;
                return new Promise((resolve, reject) => {
                    vm.$store.dispatch("dataRequestHandler", {
                        key: "GetReservationDetailById",
                        params: {
                          ModuleAction: "GetReservationDetailById",
                          ReservationId: ReservationId,
                          companyProfileId:companyProfileId
                        },
                        callback: function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                // console.log("getMultipleCorporateInvoiceGuestInfoData =====>", response.guestInfo);
                                resolve(response.guestInfo);
                            }
                        },
                    });
                });
            },
            getBTFolioSummaryDetails(GuestProfileId,itemId) {
                      let vm = this;
                      vm.isMasterFolioAvailable = null
                  vm.$store.dispatch("dataRequestHandler", {
                    key: "getBalanceTransferFolioDetails",
                    params: {
                      ModuleAction: "GetBalanceTransferFolioDetails",
                      GuestProfileId: GuestProfileId,
                      itemId: itemId,
                    },
                callback: function (err, response) {
                  if (err) {
                    return;
                  }
                  if (response) {
                    vm.balanceTransferDetails.splice(0, vm.balanceTransferDetails.length, ...response[0])
                    vm.totalBalanceTransfer = response[1][0];
                    vm.totalAmountVal = response[0].reduce((sum, currVal) => sum + currVal.Amount, 0);
                    vm.totalTaxVal = response[0].reduce((sum, currVal) => sum + currVal.Tax, 0);
                    vm.selectedResId = response[0][0].ReservationId
                    vm.folioId = response[0][0].folioId
                    vm.getReservationDetails(vm.selectedResId,GuestProfileId,itemId)  
                    vm.isMasterFolioAvailable = response[0].find(val => val.isMaster == 1).isMaster
                    // const foundItem = response[0].find(val => val.isMaster == 1);
                    // vm.isMasterFolioAvailable = foundItem ? foundItem.isMaster : undefined;
                    // console.log("vm.isMasterFolioAvailable---", MasterFolioAvailable);
                  }
                },
              });
            },
            getReservationDetails(ReservationId,companyProfileId,itemid) {
              let vm = this;
              vm.$store.dispatch("dataRequestHandler", {
                key: "GetReservationDetailById",
                params: {
                  ModuleAction: "GetReservationDetailById",
                  ReservationId: ReservationId,
                  companyProfileId:companyProfileId
                },
                callback: function (err, response) {
                  if (response) {
                    // console.log("response--:::re--thimmappa  response.guestInfo",response);
                    vm.guestData = response.guestInfo;
                    // console.log("thimmappa guestinfo",vm.guestData)
                    vm.guestEmails = response.additionalEmails;
                    vm.roomInfo = response.roomInfo;
                    // vm.emailList = response.additionalEmails?.[0]?.Emailaddress?.split();
                    vm.reservationStatus = response.roomInfo,
                    vm.guestInfo=response.guestInfo
                    vm.emailList = response.additionalEmails?.[0]?.Emailaddress?.split();
                    vm.reservationStatus = response.roomInfo
                      // vm.selectedInvoiceObj = vm.balanceTransferDetails.filter(inv => inv.ItemId == itemid)
                  }

                }
              })
            },
            callFunctionBasedOnSelection(val){
              // console.log("callFunctionBasedOnSelection",val[0])
              // const item=val[0];
              if(val.length>0){
                this.showFolioDetails = true;
                const item=val[0];
                // const item=val[val.length-1];
                this.selectedInvoiceObj=item;
                this.GuestProfileId=item.CompanyProfileId
                // this.getBTFolioSummaryDetails(item.CompanyProfileId,item.ItemId);
                // this.getReservationDetails(item.ReservationId,item.CompanyProfileId,item.ItemId)
                this.getBTFolioSummaryDetails(item.CompanyProfileId,item.ItemId);
                // this.getMultipleCorporateInvoiceData(item.ClientId,item.ReservationId,item.CompanyProfileId,item.FolioId)
              }
            },
          //   handleChildData(data) {
          //     console.log("data===========>emit data",data)
          //   this.parentComp1 = "guestProfile";
          //   this.selectedInvoiceObj1 = data.selectedInvoiceObj;
          //   this.guestInfo1 = data.guestData;
          //   this.additionalEmails1 = data.guestEmails;
          //   this.balanceTransferDetails1 = data.balanceTransferInvoiceDetails;
          //   this.roomInfo1 = data.roomInfo;
          //   this.emailList1 = data.emailList;
          //   this.folioItemsDetails1 = data.masterFolioList;
          //   this.Reservation_Status1 = data.reservationStatus;
          //   this.getTotalAmount1 = data.getTotalAmount;
          //   this.totalAmountVal1 = data.totalAmountVal;
          //   this.totalBalanceTransfer1 = data.totalBalanceTransfer;
          //   this.totalTaxVal1 = data.totalTaxVal;
          //   this.corporateDetails1 = data.corporateDetails;
          //   this.corporateEmail1 = data.corporateEmail;
          //   this.corporatePhoneNo1 = data.corporatePhoneNo;
          //   this.companyProfileId1 = data.companyProfileId;
          //   this.clientId1 = data.clientId;
          //   this.isMasterFolioAvailable1 = data.isMasterFolioAvailable;
          // }
          handleChildEvent(data) {
          //  console.log("emit data=======>",data.selectedInvoiceObj)
              this.parentComp1 = "guestProfile";
            this.selectedInvoiceObj1 = data.selectedInvoiceObj;
            this.guestInfo1 = data.guestData;
            this.additionalEmails1 = data.guestEmails;
            this.balanceTransferDetails1 = data.balanceTransferInvoiceDetails;
            this.roomInfo1 = data.roomInfo;
            this.emailList1 = data.emailList;
            this.folioItemsDetails1 = data.masterFolioList;
            this.Reservation_Status1 = data.reservationStatus;
            this.getTotalAmount1 = data.getTotalAmount;
            this.totalAmountVal1 = data.totalAmountVal;
            this.totalBalanceTransfer1 = data.totalBalanceTransfer;
            this.totalTaxVal1 = data.totalTaxVal;
            this.corporateDetails1 = data.corporateDetails;
            this.corporateEmail1 = data.corporateEmail;
            this.corporatePhoneNo1 = data.corporatePhoneNo;
            this.companyProfileId1 = data.companyProfileId;
            this.clientId1 = data.clientId;
            this.isMasterFolioAvailable1 = data.isMasterFolioAvailable;
            this.invoicedetails1=data.invoiceDetails
    }
    },
    computed: {
      fncIsPaymentReport() {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty("fncPaymentsReports")
        ) {
          return vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncPaymentsReports"
          )
            ? vm.$store.state.userEntitlementList.fncPaymentsReports
            : null;
        }
      },
      fncIsSalesReport() {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty("fncFolioReports")
        ) {
          return vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncFolioReports"
          )
            ? vm.$store.state.userEntitlementList.fncFolioReports
            : null;
        }
      },
      filteredStatusData(){
        const filtered=this.filterObjForInvoice.statusList.filter(item =>{
          return item.folioStatusName.toLowerCase().includes(this.filterSearchstatusText.toLowerCase())
        })
        return filtered;
      },
      isDisabled() {
      if (this.selectedItemCount < 1) {
          // console.log("isDisabled", true);
          return true;
        }
        // Check if all selected items have a status of 'Overdue', 'Closed', or 'Voided'
        const allInvalidStatuses = this.selectedItems.every(checkbox =>
          checkbox.isSelected && ['Overdue', 'Closed', 'Voided'].includes(checkbox.FolioStatus)
        );
        const result = allInvalidStatuses;
        return result;



    },
      showDropdownList() {
        setTimeout(() => {
        this.selectedFilterColumn = !this.selectedFilterColumn;
        $("#propertyDropDownlist").show();
        }, 10);
      }

    },
    created() {
    this.autoGroupColumnDef = {
      minWidth: 200,
    };
    // if(reportType == "foliodetail"){
    // this.sideBar = "columns";
    // }
  },
    mounted() {
      let vm = this;
      console.log("payment reports");
      // vm.setPerviousYearDate();
      vm.$store.dispatch("GetUserEntitlementsAndDefaultProperty");
      // vm.GetPaymentdetails_report(vm.reportType);
      vm.getUserProfile();
      vm.GetUserEntitlementsAndDefaultProperty();
      vm.getPropertiesBySearchText();
      vm.getPropertiesBySearchText1()
      vm.getUnitNamesBySearchText1()
      vm.GetUnitClasssListBySearchText();
      vm.getSourceListBySearchText();
      vm.getStatusBySearchText();
      // vm.Get_SalesReport(vm.reportType);
      vm.GetLedgeraccountlist();
      vm.GetPaymentstatusList();
      vm.GetFolioDetailReport();
      vm.headerColumnList = vm.salesHeaderColumnList;
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
      this.gridApi.hideOverlay();
      this.$refs.picker.clickRange([datePicker().startOf("year"), datePicker().endOf("year")]);
      setTimeout(() => {
        this.lblT();
        window.addEventListener("resize", this.lblT);
        this.valT();
        window.addEventListener("resize", this.valT);
        this.symbolText();
        window.addEventListener("resize", this.symbolText);
      }, 1000);
      $(document).click(function (e) {
        $("#propertyDropDownlist").show();
      });
      $(document).click(function (e) {
        $(".form-control.searchResultsAmenities").hide();
        vm.selectedFilterColumn = null;
      })
    },
    watch: {
      filterSearchPropertyText(newValue, oldValue) {
        this.getPropertiesBySearchText(newValue);
      },
      filterSearchPropertyText1(newValue, oldValue) {
        this.getPropertiesBySearchText1(newValue);
      },
      filterSearchUnitNameText1(searchText) {
        // if (searchText) {
        this.getUnitNamesBySearchText1(searchText);
        // }
      },
      selectedItems(newVal) {
      this.callFunctionBasedOnSelection(newVal);
    }
    }
  };
  function sumFunction(values) {
    var result = 0;
    // values.forEach(function(value) {
    //   if (typeof value === "string") {
    //     if (typeof JSON.parse(value) === "number") {
    //       result += value;
    //     }
    //   } else {
    //     if (typeof value === "number") {
    //       result += value;
    //     }
    //   }
    // });
    return result;
  }
  function dateFormatter(date) {
    if(date.value){
      return moment.utc(date.value).format("DD MMM YYYY")
    }
    else{
      return null
    }
  }
  function currencyFormatter(params) {
    if (params.value || params.value >= 0) {
      return accounting.formatMoney(params.value, {
        symbol: "$",
        format: {
          pos: "%s %v",
          neg: "%s (%v)",
          zero: "%s  %v"
        },
        thousand: ",",
        precision: 2,
        decimal: "."
      });
    } else {
      return null;
    }
  }
  function percengateFormatter(params) {
    if (params.value || params.value >= 0) {
      let valuedata = accounting.formatMoney(params.value, {
        symbol: "",
        format: {
          pos: "%s %v",
          neg: "%s (%v)",
          zero: "%s  %v"
        },
        thousand: ",",
        precision: 2,
        decimal: "."
      });
      return valuedata + "%";
    } else {
      return null;
    }
  }
  function numberFormatter(params) {
    if (params.value || params.value >= 0) {
      return accounting.formatMoney(params.value, {
        symbol: "",
        format: {
          pos: "%s %v",
          neg: "%s (%v)",
          zero: "%s  %v"
        },
        thousand: ",",
        precision: 2,
        decimal: "."
      });
    } else {
      return null;
    }
  }
  function numFormatter(params) {
    if (params.value || params.value >= 0) {
      return accounting.formatMoney(params.value, {
        symbol: "",
        format: {
          pos: "%s %v",
          neg: "%s (%v)",
          zero: "%s  %v"
        },
        thousand: ",",
        precision: 0,
        decimal: "."
      });
    } else {
      return null;
    }
  }
</script>
<style>
  /* .infiniteBody {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 100px;
  right: 20px;
} */

  /* .ag-header-cell-text {
  color: #95a6af;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 500;
}
.scrollable-menu {
  height: auto;
  max-height: 400px;
  overflow-x: hidden;
} */

  /* .cellclass:nth-child(even){
  background: rgb(22, 226, 22)
} */

  .twoDecimalPlaces,
  .textalign {
    text-align: right;
  }

  .ag-header-cell-label {
    justify-content: center;
  }
  .disabled1 input[type="checkbox"],
.disabled1 input[type="checkbox"]:before {
  cursor: not-allowed; /* Change cursor to indicate it's not clickable */
  pointer-events: none; /* Prevent interaction with the checkbox */
}

.disabled1 input[type="checkbox"]:before {
  background-color: #ccc; /* Change background color to indicate it's disabled */
  border-color: #ccc; /* Change border color to match */
}


</style>